{
  "addons.addonList": "Λίστα πρόσθετων",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Δημιουργήστε και ανακτήστε το κλειδί API από αυτόν τον σύνδεσμο",
  "addons.ambientWeatherDescription": "Ambient Weather stations (WS-5000, WS-2000, WS-2902C, ...)",
  "addons.apiKey": "Κλειδί API",
  "addons.applicationKey": "Κλειδί εφαρμογής",
  "addons.connect": "Σύνδεση",
  "addons.davisApiSecret": "Κωδικός API",
  "addons.davisApiV2Key": "Κλειδί V2 API",
  "addons.davisDescription": "Davis Weather Stations (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "Ανακτήστε τα κλειδιά V2 API από αυτόν τον σύνδεσμο",
  "addons.disconnect": "Αποσύνδεση",
  "addons.ecowittCreateAndRetrieveKeys": "Δημιουργήστε και ανακτήστε ένα κλειδί API και ένα κλειδί εφαρμογής από αυτόν τον σύνδεσμο",
  "addons.ecowittDescription": "Η Ecowitt παρέχει επαγγελματικούς μετεωρολογικούς σταθμούς wifi, ασύρματα θερμόμετρα εσωτερικού και εξωτερικού χώρου, μετρητές υγρασίας, βροχομετρητές υψηλής ακρίβειας, μετρητές ποιότητας αέρα και πολλά άλλα.",
  "addons.helpLink": "Πώς να συνδέσετε το {provider}",
  "addons.myAcuriteAccountOnHold": "Ο λογαριασμός σας έχει τεθεί σε αναμονή. Παρακαλούμε εισάγετε τον κωδικό πρόσβασής σας για να επανασυνδέσετε το λογαριασμό σας",
  "addons.myAcuriteDescription": "Η AcuRite είναι η πρωτοπόρα μάρκα μετεωρολογικών σταθμών στη Βόρεια Αμερική. Ως ηγέτης στην τεχνολογία χρόνου, θερμοκρασίας και καιρού, η AcuRite σας παρέχει λεπτομερείς πληροφορίες για το εσωτερικό και το εξωτερικό σας περιβάλλον, ώστε να μπορείτε να σχεδιάζετε την ημέρα σας με σιγουριά.",
  "addons.myAcuriteEnterCredentials": "Εισάγετε τα στοιχεία πρόσβασης My AcuRite για να συνδέσετε το λογαριασμό σας My AcuRite με το SmartMixin",
  "addons.netatmoEnergy": "Netatmo Ενέργεια",
  "addons.netatmoEnergyDescription": "Χρησιμοποιήστε τον θερμοστάτη Netatmo για να αλλάξετε τη θερμοκρασία του σπιτιού σας, από το κρεβάτι σας ή από την άλλη άκρη του κόσμου",
  "addons.netatmoThermostat": "Netatmo Θερμοστάτης",
  "addons.netatmoWeather": "Netatmo Καιρός",
  "addons.netatmoWeatherDescription": "Ο προσωπικός σας μετεωρολογικός σταθμός στο σπίτι.",
  "addons.or": "ή",
  "addons.providerAccountDisconnected": "Η σύνδεση με την υπηρεσία καιρού σας έχει λήξει. Επανασυνδεθείτε για να συνεχιστούν οι ενημερώσεις δεδομένων.",
  "addons.reconnect": "Επανασύνδεση",
  "addons.weatherflowCreateToken": "Δημιουργήστε και ανακτήστε το διακριτικό σας (token) από αυτόν τον σύνδεσμο",
  "addons.weatherflowTempestDescription": "Σύστημα καιρού Tempest με ενσωματωμένους μετρητές ανέμου και βροχής.",
  "addons.wundergroundApiKey": "Κλειδί API",
  "addons.wundergroundDescription": "Το Weather Underground είναι μια παγκόσμια κοινότητα ανθρώπων που συνδέει δεδομένα από περιβαλλοντικούς αισθητήρες, όπως μετεωρολογικούς σταθμούς και όργανα παρακολούθησης της ποιότητας του αέρα, ώστε να μπορούμε να παρέχουμε τα πλούσια, υπερτοπικά δεδομένα που χρειάζεστε για να ενισχύσετε τα ενδιαφέροντά σας.",
  "addons.wundergroundRetrieveApiKey": "Ανακτήστε το κλειδί σας API από αυτόν τον σύνδεσμο",
  "addons.wundergroundRetrieveStationId": "Ανακτήστε το αναγνωριστικό του σταθμού σας από αυτόν τον σύνδεσμο",
  "addons.wundergroundStationId": "Ταυτότητα σταθμού",
  "airQuality.airQuality": "Ποιότητα αέρα",
  "airQuality.airQualityIndex": "Δείκτης ποιότητας αέρα",
  "airQuality.aqiForecast": "Πρόγνωση ποιότητας αέρα",
  "airQuality.co": "Μονοξείδιο του άνθρακα",
  "airQuality.dailyForecast": "Ημερήσια πρόγνωση",
  "airQuality.details": "Λεπτομέρειες",
  "airQuality.dominantPollutant": "Κυρίαρχος ρύπος",
  "airQuality.good": "Καλός",
  "airQuality.goodDescription": "Η ποιότητα του αέρα θεωρείται ικανοποιητική και η ατμοσφαιρική ρύπανση αποτελεί μικρό ή μηδενικό ρίσκο.",
  "airQuality.hazardous": "Επικίνδυνος για την υγεία",
  "airQuality.hazardousDescription": "Υγειονομικός συναγερμός: οποιοσδήποτε μπορεί να παρουσιάσει σοβαρά προβλήματα υγείας.",
  "airQuality.indoorAirQuality": "Ποιότητα αέρα εσωτερικού χώρου",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Μέτριος",
  "airQuality.moderateDescription": "Η ποιότητα του αέρα είναι αποδεκτή. Ωστόσο, ορισμένοι ρύποι μπορεί να δημιουργούν ανησυχία για την υγεία ενός πολύ μικρού αριθμού ανθρώπων που είναι ασυνήθιστα ευαίσθητοι στην ατμοσφαιρική ρύπανση.",
  "airQuality.no2": "Διοξείδιο του αζώτου",
  "airQuality.o3": "Όζον",
  "airQuality.pm10": "Σωματίδια με διάμετρο 10 μm ή μικρότερη",
  "airQuality.pm25": "Σωματίδια με διάμετρο 2,5 μm ή μικρότερη",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Ανθυγιεινός για ευαίσθητα άτομα",
  "airQuality.sensitiveUnhealthyDescription": "Μέλη ευαίσθητων ομάδων ενδέχεται να έχουν επιπτώσεις στην υγεία. Το ευρύ κοινό δεν είναι πιθανό να επηρεαστεί.",
  "airQuality.so2": "Διοξείδιο του θείου",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Ανθυγιεινός",
  "airQuality.unhealthyDescription": "Mέλη ευαίσθητων ομάδων μπορεί να παρουσιάσουν σοβαρές επιπτώσεις στην υγεία τους.",
  "airQuality.veryUnhealthy": "Πολύ ανθυγιεινός",
  "airQuality.veryUnhealthyDezscription": "Προειδοποιήσεις υγείας για καταστάσεις έκτακτης ανάγκης. Όλος ο πληθυσμός είναι πιθανόν να επηρεαστεί.",
  "alerts.addAlert": "Προσθήκη ειδοποίησης",
  "alerts.addCondition": "Προσθήκη συνθήκης",
  "alerts.alertAdded": "Η ειδοποίηση προστέθηκε επιτυχώς",
  "alerts.alertAuthorizationNotice": "Οι ειδοποιήσεις λειτουργούν μόνο εάν δώσετε άδεια στο SmartMixin να εμφανίζει ειδοποιήσεις.",
  "alerts.alertDeleted": "Η ειδοποίηση διαγράφηκε με επιτυχία",
  "alerts.alertEdited": "Η ειδοποίηση τροποποιήθηκε με επιτυχία",
  "alerts.alertName": "Όνομα ειδοποίησης",
  "alerts.alertWhen": "Θέλω να ειδοποιηθώ όταν:",
  "alerts.aqiGreaterThan": "AQI μεγαλύτερο από",
  "alerts.aqiGreaterThanThreshold": "AQI μεγαλύτερος από το όριο {value}{unit}",
  "alerts.aqiLessThan": "AQI μικρότερος από",
  "alerts.aqiLessThanThreshold": "AQI μικρότερος από το όριο {value}{unit}",
  "alerts.atLeastOneCondition": "Πρέπει να προσθέσετε τουλάχιστον μία συνθήκη",
  "alerts.co2GreaterThan": "CO2 μεγαλύτερο από",
  "alerts.co2GreaterThanThreshold": "CO2 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.co2LessThan": "CO2 μικρότερο από",
  "alerts.co2LessThanThreshold": "CO2 μικρότερο από το όριο {value}{unit}",
  "alerts.conditions": "Συνθήκες",
  "alerts.createAlert": "Δημιουργία ειδοποίησης",
  "alerts.dailyPrecipitationGreaterThan": "Ημερήσιος υετός μεγαλύτερος από",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Ημερήσιος υετός πάνω από το όριο {value}{unit}",
  "alerts.deleteAlert": "Διαγραφή ειδοποίησης",
  "alerts.editAlert": "Επεξεργασία ειδοποίησης",
  "alerts.editCondition": "Επεξεργασία συνθήκης",
  "alerts.gustSpeedGreaterThan": "Ταχύτητα ριπής μεγαλύτερη από",
  "alerts.gustSpeedGreaterThanThreshold": "Ταχύτητα ριπής μεγαλύτερη από το όριο {value}{unit}",
  "alerts.gustSpeedLessThan": "Ταχύτητα ριπής μικρότερη από",
  "alerts.gustSpeedLessThanThreshold": "Ταχύτητα ριπής μικρότερη από το όριο {value}{unit}",
  "alerts.heatIndexGreaterThan": "Δείκτης θερμοκρασίας μεγαλύτερος από",
  "alerts.heatIndexGreaterThanThreshold": "Δείκτης θερμοκρασίας μεγαλύτερος από το όριο {value}{unit}",
  "alerts.heatIndexLessThan": "Δείκτης θερμοκρασίας μικρότερος από",
  "alerts.heatIndexLessThanThreshold": "Δείκτης θερμοκρασίας μικρότερος από το όριο {value}{unit}",
  "alerts.humidexGreaterThan": "Δείκτης δυσφορίας Humidex μεγαλύτερος από",
  "alerts.humidexGreaterThanThreshold": "Δείκτης δυσφορίας Humidex μεγαλύτερος από το όριο {value}{unit}",
  "alerts.humidexLessThan": "Δείκτης δυσφορίας Humidex μικρότερος από",
  "alerts.humidexLessThanThreshold": "Δείκτης δυσφορίας Humidex μικρότερος από το όριο {value}{unit}",
  "alerts.humidityGreaterThan": "Υγρασία αέρα μεγαλύτερη από",
  "alerts.humidityGreaterThanThreshold": "Υγρασία αέρα μεγαλύτερη από το όριο {value}{unit}",
  "alerts.humidityLessThan": "Υγρασία αέρα μικρότερη από",
  "alerts.humidityLessThanThreshold": "Υγρασία αέρα μικρότερη από το όριο {value}{unit}",
  "alerts.inProgress": "Σε εξέλιξη",
  "alerts.myAlerts": "Οι ειδοποιήσεις μου",
  "alerts.noConfiguredAlert": "Δεν έχετε ρυθμίσει ακόμα καμία ειδοποίηση, ξεκινήστε να προσθέσετε μία.",
  "alerts.noiseGreaterThan": "Θόρυβος μεγαλύτερος από",
  "alerts.noiseGreaterThanThreshold": "Θόρυβος μεγαλύτερος από το όριο {value}{unit}",
  "alerts.noiseLessThan": "Θόρυβος λιγότερο από",
  "alerts.noiseLessThanThreshold": "Θόρυβος μικρότερος από το όριο {value}{unit}",
  "alerts.noteOnConditions": "Σημειώστε ότι η ειδοποίηση ενεργοποιείται όταν επαληθευτούν όλες οι παρακάτω συνθήκες",
  "alerts.noTriggerHistory": "Αυτή η ειδοποίηση δεν έχει ενεργοποιηθεί ακόμη.",
  "alerts.pm10GreaterThan": "PM 10 μεγαλύτερο από",
  "alerts.pm10GreaterThanThreshold": "PM 10 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm10LessThan": "PM 10 μικρότερο από",
  "alerts.pm10LessThanThreshold": "PM 10 μικρότερο από το όριο {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 μεγαλύτερο από",
  "alerts.pm1GreaterThanThreshold": "PM 1 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm1LessThan": "PM 1 μικρότερο από",
  "alerts.pm1LessThanThreshold": "PM 1 μικρότερο από το όριο {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 μεγαλύτερο από",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 μεγαλύτερο από το όριο {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 μικρότερο από",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 μικρότερο από το όριο {value}{unit}",
  "alerts.postStormSummary": "Σύνοψη καταιγίδας",
  "alerts.postStormSynopsisHelper": "Θα λαμβάνετε μια ειδοποίηση σύνοψης μετά το τέλος κάθε βροχόπτωσης.",
  "alerts.postStormSynopsisSoleCondition": "Μια σύνοψη μετά την καταιγίδα δεν μπορεί να συνδυαστεί με άλλες συνθήκες.",
  "alerts.precipitationGreaterThan": "Ωριαίος υετός μεγαλύτερος από",
  "alerts.precipitationGreaterThanThreshold": "Ωριαίος υετός πάνω από το όριο {value}{unit}",
  "alerts.pressureGreaterThan": "Πίεση μεγαλύτερη από",
  "alerts.pressureGreaterThanThreshold": "Πίεση μεγαλύτερη από το όριο {value}{unit}",
  "alerts.pressureLessThan": "Πίεση μικρότερη από",
  "alerts.pressureLessThanThreshold": "Πίεση μικρότερη από το όριο {value}{unit}",
  "alerts.rainRateGreaterThan": "Ένταση βροχής μεγαλύτερη από",
  "alerts.rainRateGreaterThanThreshold": "Ένταση βροχής πάνω από το όριο {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Ηλιακή ακτινοβολία μεγαλύτερη από",
  "alerts.solarRadiationGreaterThanThreshold": "Ηλιακή ακτινοβολία μεγαλύτερη από το όριο {value}{unit}",
  "alerts.solarRadiationLessThan": "Ηλιακή ακτινοβολία μικρότερη από",
  "alerts.solarRadiationLessThanThreshold": "Ηλιακή ακτινοβολία μικρότερη από το όριο {value}{unit}",
  "alerts.stormChartUnavailable": "Το ιστορικό βροχής για αυτήν την καταιγίδα δεν είναι διαθέσιμο.",
  "alerts.stormDetail": "Σύνοψη καταιγίδας",
  "alerts.stormDuration": "Διάρκεια",
  "alerts.stormEnd": "Λήξη",
  "alerts.stormPeakRate": "Μέγιστη ένταση βροχής",
  "alerts.stormStart": "Έναρξη",
  "alerts.stormTotal": "Συνολική βροχόπτωση",
  "alerts.temperatureGreaterThan": "θερμοκρασία μεγαλύτερη από",
  "alerts.temperatureGreaterThanThreshold": "Θερμοκρασία μεγαλύτερη από το όριο {value}{unit}",
  "alerts.temperatureLessThan": "Θερμοκρασία μικρότερη από",
  "alerts.temperatureLessThanThreshold": "Θερμοκρασία μικρότερη από το όριο {value}{unit}",
  "alerts.thswGreaterThan": "THSW μεγαλύτερος από",
  "alerts.thswGreaterThanThreshold": "THSW μεγαλύτερος από το όριο {value}{unit}",
  "alerts.thswLessThan": "THSW μικρότερος από",
  "alerts.thswLessThanThreshold": "THSW μικρότερος από το όριο {value}{unit}",
  "alerts.thwGreaterThan": "THW μεγαλύτερος από",
  "alerts.thwGreaterThanThreshold": "THW μεγαλύτερος από το όριο {value}{unit}",
  "alerts.thwLessThan": "THW μικρότερος από",
  "alerts.thwLessThanThreshold": "THW μικρότερος από το όριο {value}{unit}",
  "alerts.triggerHistory": "Ιστορικό ειδοποίησης",
  "alerts.uvGreaterThan": "Δείκτης UV μεγαλύτερος από",
  "alerts.uvGreaterThanThreshold": "Δείκτης UV μεγαλύτερος από το όριο {value}{unit}",
  "alerts.uvLessThan": "Δείκτης UV μικρότερος από",
  "alerts.uvLessThanThreshold": "Δείκτης UV μικρότερος από το όριο {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Ορατότητα μεγαλύτερη από το όριο {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Ορατότητα μικρότερη από το όριο {value}{unit}",
  "alerts.visiblityGreaterThan": "Ορατότητα μεγαλύτερη από",
  "alerts.visiblityLessThan": "Ορατότητα μικρότερη από",
  "alerts.whichMeasure": "Για ποιά μέτρα θα θέλατε να ειδοποιείστε;",
  "alerts.whichModule": "Για ποια ενότητα θα θέλατε να ειδοποιηθείτε;",
  "alerts.windChillGreaterThan": "Ψυχρότητα ανέμου μεγαλύτερος από",
  "alerts.windChillGreaterThanThreshold": "Ψυχρότητα ανέμου μεγαλύτερος από το όριο {value}{unit}",
  "alerts.windChillLessThan": "Ψυχρότητα ανέμου μικρότερος από",
  "alerts.windChillLessThanThreshold": "Ψυχρότητα ανέμου μικρότερος από το όριο {value}{unit}",
  "alerts.windSpeedGreaterThan": "Ταχύτητα ανέμου μεγαλύτερη από",
  "alerts.windSpeedGreaterThanThreshold": "Ταχύτητα ανέμου μεγαλύτερη από το όριο {value}{unit}",
  "alerts.windSpeedLessThan": "Ταχύτητα ανέμου μικρότερη από",
  "alerts.windSpeedLessThanThreshold": "Ταχύτητα ανέμου μικρότερη από το όριο {value}{unit}",
  "astral.astronomicalSunPhase": "Αστρονομική {sunPhase}",
  "astral.civilSunPhase": "Πολιτική {sunPhase}",
  "astral.dawn": "Αυγή",
  "astral.dusk": "Σούρουπο",
  "astral.firstQuarter": "Πρώτο τέταρτο",
  "astral.fullMoon": "Πανσέληνος",
  "astral.lastQuarter": "Τελευταίο τέταρτο",
  "astral.moon": "Σελήνη",
  "astral.moonPhases": "Φάσεις Σελήνης",
  "astral.moonrise": "Ανατολή Σελήνης",
  "astral.moonset": "Δύση Σελήνης",
  "astral.nauticalSunPhase": "Ναυτική {sunPhase}",
  "astral.newMoon": "Νέα Σελήνη",
  "astral.noon": "Μεσημέρι",
  "astral.remainingDaylight": "Υπόλειπος χρόνος με φως ημέρας",
  "astral.sunrise": "Ανατολή Ηλίου",
  "astral.sunriseAndSunset": "Ανατολή Ηλίου και Δύση Ηλίου",
  "astral.sunriseAt": "Ανατολή στις {time}",
  "astral.sunset": "Δύση Ηλίου",
  "astral.sunsetAt": "Δύση στις {time}",
  "astral.totalDaylight": "Συνολικό φως ημέρας",
  "astral.waningCrescent": "Μειούμενη ημισέληνος",
  "astral.waningGibbous": "Μειούμενη κυρτή Σελήνη",
  "astral.waxingCrescent": "Αυξανόμενη ημισέληνος",
  "astral.waxingGibbous": "Αυξανόμενη κυρτή Σελήνη",
  "auth.alreadyHaveAccount": "Έχετε ήδη λογαριασμό;",
  "auth.authContainerTagline": "Ο προσωπικός σας πίνακας καιρού. Συνδέστε τους σταθμούς σας και αποκτήστε δεδομένα σε πραγματικό χρόνο στα χέρια σας.",
  "auth.backToLogin": "Επιστροφή στη σύνδεση",
  "auth.catchPhrase": "Η Πλατφόρμα Μετεωρολογικής Νοημοσύνης",
  "auth.checkYourEmail": "Ελέγξτε το email σας",
  "auth.continueWithApple": "Συνέχεια με Apple",
  "auth.continueWithFacebook": "Συνέχεια με Facebook",
  "auth.continueWithGoogle": "Συνέχεια με Google",
  "auth.email": "Διεύθυνση email",
  "auth.emailRequiredLoginFacebook": "Απαιτείται επιβεβαίωση μέσω e-mail.",
  "auth.emailVerification": "Επαλήθευση email",
  "auth.emailVerificationFailure": "Παρουσιάστηκε πρόβλημα με την επαλήθευση του email σας",
  "auth.emailVerificationSuccess": "Το email σας επαληθεύτηκε επιτυχώς",
  "auth.firstName": "Όνομα",
  "auth.forgotPassword": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
  "auth.forgotPasswordSubtitle": "Εισάγετε το email σας και θα σας στείλουμε έναν σύνδεσμο για επαναφορά του κωδικού σας.",
  "auth.lastName": "Επώνυμο",
  "auth.login": "Σύνδεση",
  "auth.loginSubtitle": "Καλώς ήρθατε πάλι! Παρακαλώ εισάγετε τα στοιχεία σας.",
  "auth.loginToSmartMixinDescription": "Εισάγετε τα στοιχεία πρόσβασης του SmartMixin για να αποκτήσετε πρόσβαση στο λογαριασμό σας",
  "auth.logout": "Αποσύνδεση",
  "auth.logoutConfirmation": "Είστε σίγουρος ότι θέλετε να αποσυνδεθείτε;",
  "auth.noAccountYet": "Δεν έχετε ακόμη λογαριασμό;",
  "auth.or": "ή",
  "auth.password": "Κωδικός",
  "auth.passwordAgain": "Επιβεβαίωση κωδικού πρόσβασης",
  "auth.passwordReset": "Επαναφορά κωδικού πρόσβασης",
  "auth.passwordResetSuccess": "Ο κωδικός πρόσβασής σας ενημερώθηκε επιτυχώς",
  "auth.register": "Δημιουργία λογαριασμού",
  "auth.registerDescription": "Δημιουργήστε έναν δωρεάν λογαριασμό SmartMixin για να συνδέσετε τους μετεωρολογικούς σταθμούς σας, να παρακολουθείτε δεδομένα καιρού και να αποκτήσετε πρόσβαση σε ισχυρά εργαλεία ανάλυσης.",
  "auth.registerSubtitle": "Δημιουργήστε τον λογαριασμό σας για να ξεκινήσετε.",
  "auth.registerSuccess": "Έχετε εγγραφεί επιτυχώς! Μόλις σας στείλαμε έναν σύνδεσμο επαλήθευσης στη διεύθυνση {emailAddress} με περαιτέρω οδηγίες.",
  "auth.restorePassword": "Επαναφορά κωδικού πρόσβασης",
  "auth.restorePasswordSuccess": "Μόλις σας στείλαμε έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης στη διεύθυνση {emailAddress} με περαιτέρω οδηγίες.",
  "auth.sendReset": "Αποστολή οδηγιών επαναφοράς",
  "auth.socialAccount": "ή χρησιμοποιήστε το λογαριασμό σας",
  "auth.welcome": "Καλώς ήρθατε στο SmartMixin",
  "auth.welcomeBack": "Καλώς ήρθατε πάλι!",
  "calendar.april": "Απρίλιος",
  "calendar.august": "Αύγουστος",
  "calendar.dateFormat": "Μορφή ημερομηνίας",
  "calendar.day": "Ημέρα",
  "calendar.december": "Δεκέμβριος",
  "calendar.end": "Τέλος",
  "calendar.february": "Φεβρουάριος",
  "calendar.hours": "Ώρες",
  "calendar.hoursShort": "Ώρες",
  "calendar.january": "Ιανουάριος",
  "calendar.july": "Ιούλιος",
  "calendar.june": "Ιούνιος",
  "calendar.last24Hours": "Τελευταίες 24 ώρες",
  "calendar.last30Days": "Τελευταίες 30 ημέρες",
  "calendar.last7Days": "Τελευταίες 7 ημέρες",
  "calendar.march": "Μάρτιος",
  "calendar.max": "Μέγιστη",
  "calendar.may": "Μάιος",
  "calendar.month": "Μήνας",
  "calendar.months": "μήνες",
  "calendar.november": "Νοέμβριος",
  "calendar.october": "Οκτώβριος",
  "calendar.oneDay": "1 ημέρα",
  "calendar.oneHour": "1 ώρα",
  "calendar.oneMonth": "1 μήνας",
  "calendar.oneWeek": "1 εβδομάδα",
  "calendar.previous24Hours": "Προηγούμενες 24 ώρες",
  "calendar.previous30Days": "Προηγούμενες 30 ημέρες",
  "calendar.previous7Days": "Προηγούμενες 7 ημέρες",
  "calendar.previousDay": "Προηγούμενη μέρα",
  "calendar.previousMonth": "Προηγούμενος μήνας",
  "calendar.previousWeek": "Προηγούμενη εβδομάδα",
  "calendar.previousYear": "Προηγούμενο έτος",
  "calendar.sameDayLastYear": "Την ίδια ημέρα πέρυσι",
  "calendar.sameMonthLastYear": "Τον ίδιο μήνα πέρυσι",
  "calendar.selectADate": "Επιλέξτε μια ημερομηνία",
  "calendar.selectAggregation": "Επιλέξτε εμφανιζόμενη τιμή",
  "calendar.selectAMonth": "Επιλέξτε ένα μήνα",
  "calendar.selectAYear": "Επιλέξτε ένα χρόνο",
  "calendar.selectGranularity": "Επιλέξτε μια λεπτομέρεια",
  "calendar.selectTimescale": "Επιλέξτε μια χρονική κλίμακα",
  "calendar.september": "Σεπτέμβριος",
  "calendar.sixHours": "6 ώρες",
  "calendar.start": "Αρχή",
  "calendar.thirtyMinutes": "30 λεπτά",
  "calendar.threeHours": "3 ώρες",
  "calendar.use24HourFormat": "Χρήση 24ωρης ώρας",
  "calendar.week": "Εβδομάδα",
  "calendar.year": "Έτος",
  "calendar.yesterday": "Χθες",
  "common.accountDeleted": "Ο λογαριασμός σας διαγράφηκε επιτυχώς.",
  "common.accountOnHold": "Η σύνδεση του λογαριασμού σας έχει λήξει. Επανασυνδεθείτε για να συνεχιστούν οι ενημερώσεις δεδομένων.",
  "common.add": "Πρόσθεση",
  "common.addAStation": "Πρόσθεση σταθμού",
  "common.addToFavorites": "Προσθήκη στα αγαπημένα",
  "common.addYourOwnStation": "Προσθέστε το δικό σας σταθμό",
  "common.alreadyPremium": "Έχετε ήδη λογαριασμό premium!",
  "common.alsoAvailableOn": "Διαθέσιμο επίσης στο:",
  "common.altitude": "Υψόμετρο",
  "common.analysis": "Ανάλυση",
  "common.aroundMe": "Πλησίον",
  "common.articleCount": "{count, plural, one {# άρθρο} other {# άρθρα}}",
  "common.articleNotFound": "Το Άρθρο δεν Βρέθηκε",
  "common.articleNotFoundDescription": "Το άρθρο που αναζητάτε δεν υπάρχει.",
  "common.average": "Μέσος όρος",
  "common.averageOverThePeriod": "Μέσος όρος κατά την περίοδο",
  "common.away": "Μακριά",
  "common.back": "Πίσω",
  "common.backToHelpCenter": "Επιστροφή στο Κέντρο Βοήθειας",
  "common.backToHome": "Επιστροφή στην Αρχική",
  "common.bad": "Κακός",
  "common.batteryLevel": "Στάθμη μπαταρίας",
  "common.bestValue": "Καλύτερη Αξία",
  "common.billingDetailsAndroid": "Για την προσφορά δωρεάν δοκιμής, δεν θα χρεωθείτε αν ακυρώσετε τουλάχιστον 24 ώρες πριν τη λήξη της δωρεάν εισαγωγικής περιόδου. Όταν η δοκιμή ολοκληρωθεί, μπορείτε να ακυρώσετε τη συνδρομή SmartMixin οποιαδήποτε στιγμή μέσω των ρυθμίσεων του λογαριασμού σας στο Google Play, αλλιώς η συνδρομή θα ανανεωθεί αυτόματα. Η ακύρωση πρέπει να γίνει τουλάχιστον 24 ώρες πριν τη λήξη της τρέχουσας περιόδου συνδρομής, ώστε να αποφύγετε τη χρέωση για την επόμενη περίοδο, όπως εμφανίζεται στο κουμπί παραπάνω. Οι πληρωμές για τη συνδρομή θα χρεώνονται στον λογαριασμό σας στο Google Play κατά την επιβεβαίωση της αγοράς και στην αρχή κάθε νέας περιόδου ανανέωσης.",
  "common.billingDetailsIos": "Για την προσφορά δωρεάν δοκιμής, δεν θα χρεωθείτε αν ακυρώσετε τουλάχιστον 24 ώρες πριν τη λήξη της δωρεάν εισαγωγικής περιόδου. Όταν η δοκιμή ολοκληρωθεί, μπορείτε να ακυρώσετε τη συνδρομή SmartMixin οποιαδήποτε στιγμή μέσω των ρυθμίσεων του λογαριασμού σας στο App Store, αλλιώς η συνδρομή θα ανανεωθεί αυτόματα. Η ακύρωση πρέπει να γίνει τουλάχιστον 24 ώρες πριν τη λήξη της τρέχουσας περιόδου συνδρομής, ώστε να αποφύγετε τη χρέωση για την επόμενη περίοδο, όπως εμφανίζεται στο κουμπί παραπάνω. Οι πληρωμές για τη συνδρομή θα χρεώνονται στον λογαριασμό σας στο App Store κατά την επιβεβαίωση της αγοράς και στην αρχή κάθε νέας περιόδου ανανέωσης.",
  "common.boilerOn": "Θέρμανση ΟΝ",
  "common.browseByCategory": "Περιήγηση ανά κατηγορία",
  "common.calendarView": "Εμφάνιση ημερολογίου",
  "common.cancel": "Ακύρωση",
  "common.cannotBeEmpty": "Αυτό το πεδίο δεν μπορεί να είναι κενό.",
  "common.cardDetails": "Στοιχεία κάρτας",
  "common.categoryNotFound": "Η κατηγορία δεν βρέθηκε",
  "common.categoryNotFoundDescription": "Αυτή η κατηγορία δεν υπάρχει ή δεν έχει άρθρα.",
  "common.charts": "Διαγράμματα",
  "common.chartView": "Προβολή διαγράμματος",
  "common.clearRecentLocations": "Εκκαθάριση όλων",
  "common.close": "Κλείσιμο",
  "common.comparison": "Σύγκριση",
  "common.contactMe": "Επικοινωνήστε μαζί μου",
  "common.currentDay": "Τρέχουσα ημέρα",
  "common.currentLocation": "Τρέχουσα τοποθεσία",
  "common.currentObservations": "Τρέχουσες παρατηρήσεις",
  "common.currentRainEvent": "Τρέχουσα εκδήλωση βροχής",
  "common.currentRate": "Τρέχουσα τιμή",
  "common.currentWeatherConditions": "Τρέχουσες συνθήκες",
  "common.customizeComparisonMetrics": "Προσαρμογή μετρικών σύγκρισης",
  "common.customizeComparisonMetricsDescription": "Σύρετε τα στοιχεία για αναδιάταξη των μετρικών σύγκρισης. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη μετρικών.",
  "common.customizeDashboard": "Προσαρμογή",
  "common.customizeDashboardDescription": "Σύρετε τα στοιχεία για αναδιάταξη του πίνακα ελέγχου. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη ενοτήτων.",
  "common.customizedStationName": "Προσαρμοσμένο όνομα σταθμού",
  "common.dailyForecast": "Ημερήσια πρόγνωση",
  "common.dashboard": "Επισκόπηση",
  "common.default": "Προεπιλογή",
  "common.defaultForecastModelChip": "Προεπιλογή · {name}",
  "common.delete": "Διαγραφή",
  "common.deleteAccount": "Διαγραφή του λογαριασμού σας",
  "common.deleteAccountConfirmation": "Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Αυτή η ενέργεια είναι μη αναστρέψιμη.",
  "common.deleteAccountDescription": "Αυτή η ενέργεια διαγράφει τον λογαριασμό σας και όλες τις πληροφορίες σας. Δεν υπάρχει επιστροφή.",
  "common.details": "Λεπτομέρειες",
  "common.edit": "Επεξεργασία",
  "common.editor": "Συντάκτης",
  "common.endTime": "Ώρα λήξης",
  "common.exitFullscreen": "Έξοδος από πλήρη οθόνη",
  "common.exploreWeatherMap": "Εξερευνήστε τον Χάρτη Καιρού",
  "common.favoriteLocations": "Αγαπημένος",
  "common.favoriteLocationsEmpty": "Μπορείτε να προσθέσετε έως και 5 αγαπημένες τοποθεσίες.",
  "common.favoriteStations": "Αγαπημένοι σταθμοί",
  "common.feedbackHelpsImprove": "Η γνώμη σας μας βοηθά να βελτιώσουμε τα άρθρα βοήθειας.",
  "common.feedbackReasonNotAnswer": "Δεν απαντά στην ερώτησή μου",
  "common.feedbackReasonOutdated": "Οι πληροφορίες είναι παρωχημένες",
  "common.feedbackReasonUnclear": "Οι οδηγίες δεν είναι σαφείς",
  "common.feedbackWhatWentWrong": "Ποιο ήταν το πρόβλημα;",
  "common.filterStationDescription": "Να μην εμφανίζονται σταθμοί με αναξιόπιστες μετρήσεις",
  "common.filterStations": "Φίλτρα σταθμών",
  "common.filterStationSourceDescription": "Επιλέξτε τους παρόχους σταθμών που θέλετε να εμφανίσετε στον χάρτη",
  "common.findStationsNearYou": "Βρείτε σταθμούς κοντά σας",
  "common.firmwareVersion": "Έκδοση firmware",
  "common.forecast": "Πρόγνωση",
  "common.forecastComparisonDescription": "Εύκολη σύγκριση αποτελεσμάτων μοντέλων πρόγνωσης από διάφορες πηγές",
  "common.forecastModelComparison": "Σύγκριση μοντέλων πρόγνωσης",
  "common.forecastModelCoverage": "Κάλυψη",
  "common.forecastModelDescription": "Περιγραφή",
  "common.forecastModelDescription_AROME": "Το μοντέλο υψηλής ανάλυσης της Météo France που επιτρέπει την επίλυση της μεταφοράς, πάνω από τη Δυτική Ευρώπη με ανάλυση 1,3 χλμ. Το καλύτερο στην κατηγορία του για βραχυπρόθεσμες προβλέψεις στη Γαλλία· ανανεώνεται κάθε τρεις ώρες.",
  "common.forecastModelDescription_ARPEGE_EU": "Η ευρωπαϊκή φωλιά του μοντέλου ARPEGE της Météo France με ανάλυση 10 χλμ. Μεσοπρόθεσμες προβλέψεις πάνω από την Ευρώπη, ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Το παγκόσμιο αριθμητικό μοντέλο πρόγνωσης καιρού της Météo France με ανάλυση 25 χλμ, που τρέχει έως περίπου 4 ημέρες. Ανανεώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_DMI_DINI": "Το HARMONIE DINI της DMI: ένα μοντέλο που επιτρέπει τη συναγωγή πάνω από τη βορειοδυτική Ευρώπη — Δανία, Μπενελούξ, Ιρλανδία, Ηνωμένο Βασίλειο και Σκανδιναβία — με ανάλυση 2 χλμ που φτάνει έως τις 60 ώρες, ανανεώνεται οκτώ φορές την ημέρα. Περιέχει τροποποιημένα ανοικτά δεδομένα της DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Το παγκόσμιο ντετερμινιστικό σύστημα πρόβλεψης της Environment Canada: ένα παγκόσμιο μεσοπρόθεσμο μοντέλο με ανάλυση 15 χλμ που τρέχει έως 10 ημέρες, ενημερώνεται δύο φορές την ημέρα.",
  "common.forecastModelDescription_EC_HRDPS": "Το ντετερμινιστικό σύστημα πρόβλεψης υψηλής ανάλυσης της Environment Canada: ένα μοντέλο που επιτρέπει τη συναγωγή πάνω από τον Καναδά και τις βόρειες Ηνωμένες Πολιτείες με ανάλυση 2,5 χλμ που φτάνει έως τις 48 ώρες, ανανεώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_EC_RDPS": "Το περιφερειακό ντετερμινιστικό σύστημα πρόβλεψης της Environment Canada: ένα μεσοπρόθεσμο μοντέλο πάνω από τη Βόρεια Αμερική με ανάλυση 10 χλμ, ανανεώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_ECMWF_HRES": "Το κορυφαίο μοντέλο υψηλής ανάλυσης (IFS) του Ευρωπαϊκού Κέντρου Μεσοπρόθεσμων Μετεωρολογικών Προγνώσεων, ευρέως αναγνωρισμένο ως το κορυφαίο παγκόσμιο σύστημα πρόγνωσης. Καλύπτει ολόκληρο τον πλανήτη με ανάλυση 25 χλμ. έως 15 ημέρες, με ενημέρωση τέσσερις φορές την ημέρα. Περιέχει τροποποιημένα ανοικτά δεδομένα του ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Το ναυαρχίδα μοντέλο μεσαίας εμβέλειας της NOAA. Καλύπτει ολόκληρο τον πλανήτη με ανάλυση 25 χλμ έως 16 ημέρες, ενημερώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_HRRR_CONUS": "Το High-Resolution Rapid Refresh της NOAA: ένα μοντέλο που επιτρέπει την επίλυση της μεταφοράς, πάνω από τις ηπειρωτικές ΗΠΑ με ανάλυση 3 χλμ, ανανεώνεται κάθε ώρα. Καταλληλότερο για πολύ βραχυπρόθεσμες προβλέψεις καταιγίδων και ακραίων καιρικών συνθηκών.",
  "common.forecastModelDescription_ICON": "Το παγκόσμιο μοντέλο ICON της DWD με ανάλυση 13 km που καλύπτει ολόκληρο τον πλανήτη έως και 7,5 ημέρες, ενημερώνεται τέσσερις φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "Το ICON-2I της ItaliaMeteo, που λειτουργεί από κοινού με την ARPAE: ένα μοντέλο που επιτρέπει τη συναγωγή πάνω από την Ιταλία με ανάλυση 2,2 χλμ που φτάνει έως τις 72 ώρες, ανανεώνεται δύο φορές την ημέρα. Περιέχει ανοικτά δεδομένα της ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Η εκτέλεση ελέγχου του ICON-CH1-EPS της MeteoSwiss: ένα μοντέλο που επιτρέπει τη συναγωγή πάνω από τις Άλπεις με ανάλυση 1 χλμ που φτάνει έως τις 33 ώρες, ανανεώνεται κάθε τρεις ώρες.",
  "common.forecastModelDescription_ICON_CH2": "Η εκτέλεση ελέγχου του ICON-CH2-EPS της MeteoSwiss: ένα μοντέλο που επιτρέπει τη συναγωγή πάνω από τις Άλπεις — Ελβετία και τη γύρω αλπική περιοχή — με ανάλυση 2,1 χλμ που φτάνει έως τις 120 ώρες, ανανεώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_ICON_DE": "Το μοντέλο υψηλής ανάλυσης της DWD που επιτρέπει την επίλυση της μεταφοράς, πάνω από τη Γερμανία και τις γύρω χώρες με ανάλυση 2,2 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται δύο φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Η ευρωπαϊκή φωλιά του μοντέλου ICON της DWD με ανάλυση 7 χλμ που καλύπτει την Ευρώπη και τον Βόρειο Ατλαντικό. Μεσοπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Η ανοιχτή υπηρεσία πρόγνωσης καιρού του Νορβηγικού Μετεωρολογικού Ινστιτούτου, που αναμιγνύει σκανδιναβικά μοντέλα υψηλής ανάλυσης με δεδομένα ECMWF για να παρέχει παγκόσμιες προβλέψεις έως 10 ημέρες μπροστά.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Φωλιά AROME πάνω από τις γαλλικές Αντίλλες (Γουαδελούπη, Μαρτινίκα) με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Φωλιά AROME πάνω από τη Γαλλική Γουιάνα με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Φωλιά AROME πάνω από τη Νέα Καληδονία με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Φωλιά AROME πάνω από τη Γαλλική Πολυνησία με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Φωλιά AROME πάνω από τη Ρεϋνιόν και τη Μαγιότ με ανάλυση 2,5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_NAM_CONUS": "Η φωλιά του North American Mesoscale μοντέλου της NOAA πάνω από τις ηπειρωτικές ΗΠΑ με ανάλυση 5 χλμ. Βραχυπρόθεσμες προβλέψεις ανανεώνονται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Το North American Mesoscale μοντέλο της NOAA που καλύπτει όλη τη Βόρεια Αμερική με ανάλυση 32 χλμ. Ανανεώνεται τέσσερις φορές την ημέρα.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Η ναυαρχίδα πρόγνωση του SmartMixin. Για κάθε ώρα στην τοποθεσία σας, επιλέγουμε το καλύτερο διαθέσιμο μοντέλο — συνήθως ένα περιφερειακό μοντέλο υψηλής ανάλυσης όπου υπάρχει (AROME στη Γαλλία, ICON-D2 στη Γερμανία, HRRR στις ΗΠΑ, ARPEGE Europe σε ολόκληρη την ήπειρο…) και επιστρέφουμε σε ένα παγκόσμιο μοντέλο αλλού — και έπειτα γεμίζουμε τυχόν κενά από γειτονικές πηγές. Το αποτέλεσμα είναι μια ενιαία, αδιάλειπτη πρόγνωση που καλύπτει οπουδήποτε στον κόσμο έως 14 ημέρες, ανανεώνεται αυτόματα όποτε ενημερώνεται κάποιο από τα υποκείμενα μοντέλα.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Η αποκλειστική παγκόσμια πρόγνωση της Weatherflow που αναμιγνύει πολλαπλά αριθμητικά μοντέλα καιρού με παρατηρήσεις από το δίκτυό της Tempest μετεωρολογικών σταθμών. 10ήμερος παγκόσμιος ορίζοντας.",
  "common.forecastModelDetailTitle": "Μοντέλο πρόγνωσης",
  "common.forecastModelScopeGlobal": "Παγκόσμιο",
  "common.forecastModelScopeGlobalDescription": "Αυτό το μοντέλο καλύπτει ολόκληρο τον πλανήτη.",
  "common.forecastModelScopeRegional": "Περιφερειακό",
  "common.forecastModelScopeRegionalDescription": "Αυτό το μοντέλο καλύπτει μόνο μια συγκεκριμένη περιοχή.",
  "common.forecastModelSpecifications": "Προδιαγραφές",
  "common.forecastSources": "Πηγές πρόγνωσης",
  "common.freeAccount": "Δωρεάν λογαριασμός",
  "common.freeSubscription": "Δωρεάν συνδρομή premium",
  "common.freeTrialForPeriod": "Δωρεάν δοκιμή για {period} ημέρες",
  "common.frequency": "Συχνότητα",
  "common.full": "Πλήρης",
  "common.fullscreen": "Πλήρης οθόνη",
  "common.getStartedFree": "Ξεκινήστε Δωρεάν",
  "common.getUnlimitedAccess": "Απεριόριστη πρόσβαση σε:",
  "common.good": "Καλό",
  "common.hail": "Χαλάζι",
  "common.help": "Βοήθεια",
  "common.helpCategoryAccount": "Λογαριασμός",
  "common.helpCategoryBilling": "Χρεώσεις",
  "common.helpCategoryGettingStarted": "Ξεκινώντας",
  "common.helpCategoryProviders": "Πάροχοι",
  "common.helpCategoryStations": "Σταθμοί",
  "common.helpCategoryTroubleshooting": "Αντιμετώπιση Προβλημάτων",
  "common.helpCenter": "Κέντρο βοήθειας",
  "common.helpCenterDescription": "Βρείτε απαντήσεις σε συχνές ερωτήσεις και μάθετε πώς να αξιοποιήσετε στο έπακρο το SmartMixin.",
  "common.hg": "Προστασία από παγετό",
  "common.hidden": "Κρυφά",
  "common.hiddenSensors": "Κρυμμένοι αισθητήρες",
  "common.hiddenStations": "Κρυμμένοι σταθμοί",
  "common.hiddenStationsDescription": "Μπορείτε να απομακρύνετε ένα σταθμό πατώντας το εικονίδιο των ματιών δίπλα του.",
  "common.high": "Υψηλό",
  "common.home": "Σπίτι",
  "common.homeConnectService": "Έχετε μετεωρολογικό σταθμό; Συνδέστε την υπηρεσία σας",
  "common.homeInformation": "Πληροφορίες για το σπίτι",
  "common.homeIntroduction": "Ξεκινήστε να συνδέετε τους εξωτερικούς σας λογαριασμούς για να απολαμβάνετε τις λειτουργίες του SmartMixin",
  "common.homeName": "Όνομα σπιτιού",
  "common.homeSubtitle": "Ο καιρός σας, όλα σε ένα μέρος",
  "common.horizon": "Ορίζοντας",
  "common.horizonValue": "μέχρι {value} ώρες",
  "common.iDontKnowYet": "Δεν ξέρω ακόμα",
  "common.indoor": "Εσωτερικός χώρος",
  "common.lastRainEvent": "Τελευταία εκδήλωση βροχής",
  "common.lastUpdate": "Τελευταία ενημέρωση",
  "common.legendHeavy": "Ισχυρή",
  "common.legendLight": "Ασθενής",
  "common.legendLightningHelp": "Το χρώμα δείχνει την ηλικία κάθε κεραυνού τα τελευταία {minutes} λεπτά — οι πιο πρόσφατοι με λευκό, οι παλαιότεροι με σκούρο κόκκινο.",
  "common.legendNewest": "Νεότερα",
  "common.legendOldest": "Παλαιότερα",
  "common.legendStationsHelp": "Το χρώμα του δείκτη αντικατοπτρίζει την τιμή της επιλεγμένης μέτρησης.",
  "common.lightningDataAttribution": "Δεδομένα κεραυνών: Blitzortung.org",
  "common.lightningStrikes": "Κεραυνοί",
  "common.lightningStrikesDescription": "Εμφάνιση κεραυνών σε πραγματικό χρόνο στον χάρτη",
  "common.linkToSection": "Σύνδεσμος σε αυτήν την ενότητα",
  "common.loading": "Φόρτωση",
  "common.location": "Τοποθεσία",
  "common.locationAddedToFavorites": "Η τοποθεσία προστέθηκε στα αγαπημένα",
  "common.locationNotGranted": "Η άδεια τοποθεσίας δεν χορηγείται. Επιτρέψτε την πρόσβαση στην τοποθεσία σας στις ρυθμίσεις της συσκευής.",
  "common.locationRemovedFromFavorites": "Η τοποθεσία αφαιρέθηκε από τα αγαπημένα",
  "common.locations": "Τοποθεσίες",
  "common.low": "Χαμηλή",
  "common.manage": "Διαχείριση",
  "common.manageAccount": "Διαχείριση λογαριασμού",
  "common.manageMySubscription": "Διαχείριση της συνδρομής μου",
  "common.manageSensors": "Διαχείριση αισθητήρων",
  "common.manageSensorsDescription": "Σύρετε στοιχεία για αναδιάταξη αισθητήρων. Πατήστε το εικονίδιο ματιού για εμφάνιση ή απόκρυψη αισθητήρων. Πατήστε ένα όνομα για μετονομασία.",
  "common.manualBoost": "Χειροκίνητη ενίσχυση",
  "common.manualSetpointUntil": "Χειροκίνητο σημείο ρύθμισης μέχρι",
  "common.mapLayers": "Επίπεδα χάρτη",
  "common.mapLegend": "Υπόμνημα χάρτη",
  "common.maxFavoriteLocationsReached": "Μπορείτε να έχετε μόνο έως και 5 αγαπημένες τοποθεσίες. Αφαιρέστε ένα για να προσθέσετε ένα άλλο.",
  "common.maximum": "Μέγιστο",
  "common.measureToDisplay": "Μετρήσεις για την εμφάνιση",
  "common.medium": "Μεσαίο",
  "common.meshSize": "Μέγεθος πλέγματος",
  "common.minimum": "Ελάχιστο",
  "common.minRead": "{minutes} λεπτά ανάγνωση",
  "common.modifyFavoriteStations": "Τροποποιήστε τους αγαπημένους σταθμούς",
  "common.modifyFavoriteStationsDescription": "Μπορείτε να αναδιατάσετε τους αγαπημένους σας σταθμούς, τραβώντας τους. Μπορείτε επίσης να τα καταργήσετε από τη λίστα.",
  "common.moduleType": "Τύπος μονάδας",
  "common.monthTotal": "Περίληψη μήνα",
  "common.more": "Περισσότερα",
  "common.moreInformation": "Περισσότερες πληροφορίες",
  "common.myLocation": "Η τοποθεσία μου",
  "common.nearbyWeatherStations": "Κοντινοί καιρικοί σταθμοί",
  "common.next": "Επόμενος",
  "common.nextHours": "Οι επόμενες ώρες",
  "common.no": "Όχι",
  "common.noAccountNeeded": "Δεν απαιτείται λογαριασμός",
  "common.noDataForThisPeriod": "Δεν υπάρχουν στοιχεία για αυτή την περίοδο",
  "common.noLocationsFound": "Δεν βρέθηκαν τοποθεσίες",
  "common.noNetatmoWeatherStationYet": "Δεν έχετε ακόμη μετεωρολογικό σταθμό Netatmo",
  "common.noOutdoorModule": "Δεν υπάρχει λειτουργική εξωτερική μονάδα για αυτό το σταθμό",
  "common.noSearchResults": "Κανένα άρθρο δεν ταιριάζει με την αναζήτησή σας",
  "common.noStationsFound": "Δεν βρέθηκαν σταθμοί",
  "common.noThermostatYet": "Δεν έχετε ακόμη θερμοστάτη",
  "common.notNow": "Όχι τώρα",
  "common.notPurchasedYet": "Φαίνεται ότι αυτό δεν έχει αγοραστεί ακόμα.",
  "common.noWeatherStation": "Δεν υπάρχει μετεωρολογικός σταθμός",
  "common.noWeatherStationYet": "Δεν έχετε ακόμα μετεωρολογικό σταθμό",
  "common.numberOfActiveWarnings": "{warning_count} ενεργές προειδοποιήσεις καιρού",
  "common.onThisPage": "Σε αυτήν τη σελίδα",
  "common.openSettings": "Ανοίξτε τις ρυθμίσεις",
  "common.orChooseMonthly": "Ή επιλέξτε μηνιαία:",
  "common.outdatedModule": "Τα δεδομένα αυτής της μονάδας είναι ξεπερασμένα",
  "common.outdoor": "Εξωτερικός χώρος",
  "common.outdoorTemperature": "Εξωτερική θερμοκρασία",
  "common.pageNotFound": "Η Σελίδα Δεν Βρέθηκε",
  "common.pageNotFoundDescription": "Η σελίδα που αναζητάτε δεν υπάρχει ή έχει μετακινηθεί.",
  "common.passwordUpdated": "Ο κωδικός πρόσβασης ενημερώθηκε με επιτυχία",
  "common.personalWeatherIntelligence": "Η Προσωπική σας Μετεωρολογική Νοημοσύνη",
  "common.platformMobileApp": "Εφαρμογή κινητού",
  "common.platformMobileOnly": "Μόνο στην εφαρμογή κινητού",
  "common.platformWebApp": "Εφαρμογή ιστού",
  "common.platformWebOnly": "Μόνο στην εφαρμογή ιστού",
  "common.popularArticles": "Δημοφιλή άρθρα",
  "common.premiumAccount": "Λογαριασμός Premium",
  "common.premiumDescription": "Η συνδρομή Premium ξεκλειδώνει πολλές πρόσθετες λειτουργίες, όπως προηγμένη ανάλυση καιρού, συγκρίσεις διαγραμμάτων, περιφερειακά μοντέλα πρόγνωσης και πολλά άλλα.",
  "common.premiumFeatureAlerts": "Ειδοποιήσεις Καιρού",
  "common.premiumFeatureAnalysis": "Προηγμένη Ανάλυση Καιρού",
  "common.premiumFeatureCharts": "Συγκρίσεις Γραφημάτων",
  "common.premiumFeatureExport": "Εξαγωγή Δεδομένων",
  "common.premiumFeatureForecast": "Περιφερειακά Μοντέλα Πρόγνωσης",
  "common.premiumFeatureNotification": "Widget Γραμμής Κατάστασης",
  "common.premiumFeatureTitle": "Premium Λειτουργία",
  "common.premiumFeatureWidgets": "Widgets αρχικής οθόνης",
  "common.pressureSummary": "Περίληψη πίεσης",
  "common.previous": "Προηγούμενος",
  "common.previousHours": "Προηγούμενες ώρες",
  "common.profileUpdated": "Το προφίλ ενημερώθηκε με επιτυχία",
  "common.purchasedNetatmoPro": "Αγοράσατε προηγουμένως το Netatmo Pro ({date}). Σας δίνει πρόσβαση σε ένα υποσύνολο premium λειτουργιών. Εγγραφείτε σε μία από τις παρακάτω προσφορές αν θέλετε να έχετε πρόσβαση σε όλες τις premium λειτουργίες.",
  "common.radarDataAttribution": "Δεδομένα ραντάρ: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Βροχή",
  "common.rainEvents": "Εκδήλωση βροχής",
  "common.rainfallMeasurement": "Μέτρηση βροχόπτωσης",
  "common.rainRadar": "Ραντάρ βροχής",
  "common.rainRadarDescription": "Εμφάνιση ραντάρ βροχής στον χάρτη",
  "common.rainSummary": "Περίληψη βροχής",
  "common.range": "Εύρος",
  "common.recentLocations": "Πρόσφατες",
  "common.recentLocationsEmpty": "Το πρόσφατο ιστορικό σας είναι κενό.",
  "common.recentStations": "Πρόσφατοι σταθμοί",
  "common.relatedArticles": "Σχετικά Άρθρα",
  "common.relay": "Αναμετάδοση",
  "common.removeFromFavorites": "Αφαίρεση από τα αγαπημένα",
  "common.renameSensors": "Μετονομασία αισθητήρων",
  "common.resetZoom": "Επαναφορά Zoom",
  "common.restorePurchase": "Επαναφορά αγοράς",
  "common.room": "Δωμάτιο",
  "common.rooms": "Δωμάτια",
  "common.savingsPercent": "Εξοικονόμηση {percent}%",
  "common.searchArticles": "Αναζήτηση άρθρων...",
  "common.searchForALocation": "Αναζήτηση τοποθεσίας...",
  "common.searchForLocation": "Αναζήτηση τοποθεσίας",
  "common.searchForWeatherStation": "Αναζήτηση μετεωρολογικού σταθμού",
  "common.searchResults": "Αποτελέσματα αναζήτησης",
  "common.searchResultsEmpty": "Δεν βρέθηκαν αποτελέσματα.",
  "common.searchResultsFound": "{count, plural, one {Βρέθηκε # αποτέλεσμα} other {Βρέθηκαν # αποτελέσματα}}",
  "common.searchStationsDescription": "Εισαγάγετε μια πόλη, διεύθυνση ή όνομα τόπου για να βρείτε κοντινούς μετεωρολογικούς σταθμούς.",
  "common.searchStationsHint": "Χρησιμοποιήστε τη γραμμή αναζήτησης παραπάνω για να ανακαλύψετε μετεωρολογικούς σταθμούς οπουδήποτε στον κόσμο.",
  "common.selectStationForComparison": "Επιλέξτε ένα σταθμό για σύγκριση",
  "common.selectWeatherForecastProvider": "Παρακαλώ επιλέξτε έναν πάροχο καιρού",
  "common.serialNumber": "Σειριακός αριθμός",
  "common.share": "Κοινοποίηση",
  "common.shareOutdoorMeasures": "Κοινοποιήστε τις μετρήσεις σας απο τους εξωτερικούς χώρους.",
  "common.shareOutdoorMeasuresDescription": "Συμμετάσχετε στην κοινότητα του SmartMixin, κάνοντας ορατές τις μετρήσεις σας από εξωτερικούς χώρους σε άλλους χρήστες. Η μετρήσεις εσωτερικών χώρων δεν θα κοινοποιηθούν ποτέ.",
  "common.shareYourWeather": "Κοινοποιήστε τον καιρό σας",
  "common.signalStrength": "Ισχύς σήματος",
  "common.skip": "Παράλειψη",
  "common.smartThermostat": "Έξυπνος θερμοστάτης",
  "common.smartValve": "Έξυπνη βαλβίδα",
  "common.snow": "Χιόνι",
  "common.start": "Αρχή",
  "common.startFreeTrial": "Έναρξη Δωρεάν Δοκιμής",
  "common.startTime": "Ώρα έναρξης",
  "common.station": "σταθμός",
  "common.stationAddedToFavorites": "Ο σταθμός προστέθηκε στα αγαπημένα",
  "common.stationComparison": "Σύγκριση σταθμών",
  "common.stationComparisonDescription": "Σύγκριση ιστορικών δεδομένων καιρού με άλλο σταθμό",
  "common.stationInformation": "Πληροφορίες σταθμού",
  "common.stationName": "Όνομα σταθμού",
  "common.stationObservationsDescription": "Εμφάνιση των τελευταίων παρατηρήσεων από μετεωρολογικούς σταθμούς",
  "common.stationRemovedFromFavorites": "Ο σταθμός αφαιρέθηκε από τα αγαπημένα",
  "common.stations": "σταθμοί",
  "common.stationsNear": "Σταθμοί κοντά σε",
  "common.stationType": "Τύπος σταθμού",
  "common.statusOffline": "Εκτός σύνδεσης",
  "common.statusOnline": "Συνδεδεμένο",
  "common.statusStale": "Παλιό",
  "common.statusSyncing": "Συγχρονισμός",
  "common.stillNeedHelp": "Χρειάζεστε ακόμα βοήθεια;",
  "common.stillNeedHelpDescription": "Αν αυτό το άρθρο δεν απάντησε στην ερώτησή σας, θα χαρώ να σας βοηθήσω προσωπικά.",
  "common.subscribeNow": "Εγγραφή τώρα - χωρίς δοκιμαστική περίοδο",
  "common.sumOverThePeriod": "Σύνολο κατά τη διάρκεια της περιόδου",
  "common.switchToPremium": "Αλλαγή σε SmartMixin Premium",
  "common.temperatureShort": "Θερμ.",
  "common.temperatureSummary": "Περίληψη θερμοκρασίας",
  "common.thankYouForFeedback": "Ευχαριστούμε για την ανατροφοδότησή σας!",
  "common.thenPrice": "μετά {price}",
  "common.timeSelection": "Επιλογή ώρας",
  "common.timezone": "Ζώνη ώρας",
  "common.totalDuration": "Συνολική διάρκεια",
  "common.tryAnotherLocation": "Δεν μπορέσαμε να βρούμε μετεωρολογικούς σταθμούς κοντά σε αυτή την τοποθεσία. Δοκιμάστε να αναζητήσετε σε διαφορετική περιοχή.",
  "common.unknown": "Άγνωστος",
  "common.untilChanged": "Μέχρι να αλλάξει",
  "common.untilTime": "Μέχρι {time}",
  "common.updateAvailable": "Διαθέσιμη ενημέρωση",
  "common.updateAvailableOpenAppStore": "Πατήστε για να ανοίξετε το App Store",
  "common.updateAvailableOpenGooglePlay": "Πατήστε για να ανοίξετε το Google Play",
  "common.updateAvailableVersion": "Διαθέσιμη ενημέρωση: v{version}",
  "common.upgrade": "Αναβάθμιση",
  "common.upgradeRequiredAndroid": "Απαιτείται αναβάθμιση της εφαρμογής σας. Επισκεφθείτε το Google Play για να αναβαθμίσετε.",
  "common.upgradeRequiredIos": "Απαιτείται αναβάθμιση της εφαρμογής σας. Επισκεφθείτε το App Store για να αναβαθμίσετε.",
  "common.validate": "Επικύρωση",
  "common.validEmail": "Απαιτείται έγκυρη διεύθυνση email.",
  "common.very_low": "Πολύ χαμηλή",
  "common.visitNetatmoWebsite": "Επισκεφθείτε τον ιστότοπο της Netatmo",
  "common.wasArticleHelpful": "Σας φάνηκε χρήσιμο αυτό το άρθρο;",
  "common.weatherCondition": "Καιρικές συνθήκες",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "Η NC Βροχή, είναι μια πρόσθετη πηγή δεδομένων που παρέχεται μέσω του Tempest Weather System, το οποίο τροφοδοτείται από την τεχνολογία Nearcast. Τα δεδομένα NC Rain είναι μια εκτίμηση της μέσης συνολικής βροχόπτωσης γύρω από το Tempest σας σε επίπεδο περιοχής.",
  "common.weatherForecastModels": "Μοντέλα πρόγνωσης καιρού",
  "common.weatherIntelligencePlatform": "Η Πλατφόρμα Μετεωρολογικής Νοημοσύνης",
  "common.weatherMap": "Χάρτης καιρού",
  "common.weatherMapMetaDescription": "Το SmartMixin παρέχει διαδραστικούς χάρτες καιρού και ραντάρ για καιρικές συνθήκες σε όλο τον κόσμο.",
  "common.weatherObservations": "Παρατηρήσεις καιρού",
  "common.weatherStation": "Μετεωρολογικός σταθμός",
  "common.weatherStations": "Μετεωρολογικοί σταθμοί",
  "common.welcome": "Καλώς ήρθατε στο SmartMixin!",
  "common.whenBackHome": "Πότε θα επιστρέψετε στο σπίτι;",
  "common.wifiStrength": "Ισχύς WiFi",
  "common.wind": "Άνεμος",
  "common.windMeasurement": "Μέτρηση ανέμου",
  "common.windSpeed": "Ταχύτητα ανέμου",
  "common.windSummary": "Περίληψη ανέμου",
  "common.yearToDate": "Έτος μέχρι σήμερα",
  "common.yes": "Ναι",
  "common.zoomImage": "Μεγέθυνση εικόνας",
  "forecastMaps.addColor": "Προσθήκη χρώματος",
  "forecastMaps.addLayer": "Προσθήκη επιπέδου",
  "forecastMaps.autoPreview": "Αυτόματο",
  "forecastMaps.backToMaps": "Πίσω στους χάρτες",
  "forecastMaps.browseMaps": "Περιήγηση στους χάρτες",
  "forecastMaps.build": "Δημιουργία",
  "forecastMaps.buildCompleted": "Η δημιουργία ολοκληρώθηκε",
  "forecastMaps.builderMetaDescription": "Συνθέστε προσαρμοσμένους χάρτες πρόγνωσης από τα επίπεδα των μετεωρολογικών μοντέλων.",
  "forecastMaps.builderTitle": "Εργαλείο δημιουργίας χαρτών",
  "forecastMaps.buildFailed": "Η δημιουργία απέτυχε. Δοκιμάστε ξανά.",
  "forecastMaps.buildNotPossible": "Αυτός ο χάρτης δεν μπορεί να δημιουργηθεί ακόμη — δεν υπάρχουν διαθέσιμα δεδομένα πρόγνωσης.",
  "forecastMaps.buildProgress": "Απόδοση… {completed}/{total} βήματα",
  "forecastMaps.buildStarting": "Έναρξη δημιουργίας…",
  "forecastMaps.byModel": "Ανά μοντέλο",
  "forecastMaps.byZone": "Ανά ζώνη",
  "forecastMaps.colormap": "Χρωματική κλίμακα",
  "forecastMaps.colormapCustom": "Προσαρμοσμένα χρώματα",
  "forecastMaps.colormapGroupDomain": "Μετεωρολογικά πρότυπα",
  "forecastMaps.colormapGroupMatplotlib": "Επιστημονικά πρότυπα",
  "forecastMaps.colorScale": "Χρωματική κλίμακα",
  "forecastMaps.comingSoon": "Αυτή η προβολή έρχεται σύντομα.",
  "forecastMaps.contourLevels": "Επίπεδα ισοϋψών",
  "forecastMaps.countryCanada": "Καναδάς",
  "forecastMaps.countryFrance": "Γαλλία",
  "forecastMaps.countryGermany": "Γερμανία",
  "forecastMaps.countryItaly": "Ιταλία",
  "forecastMaps.countryScandinavia": "Σκανδιναβία",
  "forecastMaps.countrySpain": "Ισπανία",
  "forecastMaps.countrySwitzerland": "Ελβετία",
  "forecastMaps.countryUnitedStates": "Ηνωμένες Πολιτείες",
  "forecastMaps.customColormapMinColors": "Μια προσαρμοσμένη χρωματική κλίμακα απαιτεί τουλάχιστον δύο χρώματα",
  "forecastMaps.customExtent": "Προσαρμοσμένη έκταση",
  "forecastMaps.deleteMap": "Διαγραφή χάρτη",
  "forecastMaps.deleteMapBody": "Ο χάρτης «{name}» και οι αποδόσεις του θα διαγραφούν οριστικά.",
  "forecastMaps.deleteMapTitle": "Διαγραφή αυτού του χάρτη;",
  "forecastMaps.displayName": "Εμφανιζόμενο όνομα",
  "forecastMaps.downloadMp4": "Λήψη MP4",
  "forecastMaps.downscaling": "Συντελεστής αραίωσης ανεμοδεικτών",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Σχεδίαση περιοχής",
  "forecastMaps.east": "Ανατολή",
  "forecastMaps.editMap": "Επεξεργασία χάρτη",
  "forecastMaps.exportBuilding": "Προετοιμασία βίντεο…",
  "forecastMaps.exportError": "Η εξαγωγή του βίντεο απέτυχε. Δοκιμάστε ξανά.",
  "forecastMaps.exportMp4": "Εξαγωγή MP4",
  "forecastMaps.exportNotReady": "Το βίντεο δεν είναι έτοιμο ακόμη. Δοκιμάστε ξανά αργότερα.",
  "forecastMaps.extentDrawHint": "Σύρετε στον χάρτη για να σχεδιάσετε την περιοχή",
  "forecastMaps.extentInvalid": "Η δύση πρέπει να είναι μικρότερη από την ανατολή και ο νότος μικρότερος από τον βορρά",
  "forecastMaps.extentPanZoomHint": "Μετακινήστε και κάντε ζουμ μέχρι η περιοχή να γεμίσει το πλαίσιο",
  "forecastMaps.flipbookView": "Κινούμενη εικόνα",
  "forecastMaps.forecastModel": "Μοντέλο πρόγνωσης",
  "forecastMaps.forkAndEdit": "Αντιγραφή και επεξεργασία",
  "forecastMaps.height": "Ύψος (ίντσες)",
  "forecastMaps.hourOffset": "+{hour} ώρ.",
  "forecastMaps.invalidHexColor": "Μη έγκυρο χρώμα — χρησιμοποιήστε #RRGGBB",
  "forecastMaps.layers": "Επίπεδα",
  "forecastMaps.layerTypeBarbs": "Ανεμοδείκτες",
  "forecastMaps.layerTypeContour": "Ισοϋψείς γραμμές",
  "forecastMaps.layerTypeFilledContour": "Γεμισμένες ισοϋψείς",
  "forecastMaps.layerTypeMagnitude": "Μέγεθος",
  "forecastMaps.layerTypeRaster": "Ράστερ",
  "forecastMaps.layerTypeVectorField": "Διανυσματικό πεδίο",
  "forecastMaps.leave": "Έξοδος",
  "forecastMaps.levelsCount": "Πλήθος",
  "forecastMaps.levelsInvalid": "Μη έγκυρα επίπεδα ισοϋψών",
  "forecastMaps.levelsModeArange": "Σταθερό βήμα",
  "forecastMaps.levelsModeExplicit": "Ρητές τιμές",
  "forecastMaps.levelsModeLinspace": "Ομοιόμορφη κατανομή (πλήθος)",
  "forecastMaps.levelsStep": "Βήμα",
  "forecastMaps.levelsValues": "Τιμές",
  "forecastMaps.levelsValuesHint": "Διαχωρισμένες με κόμματα, αύξουσες",
  "forecastMaps.localTimeHint": "Εμφανίζεται στην τοπική σας ώρα",
  "forecastMaps.map": "Χάρτης",
  "forecastMaps.mapDescription": "Περιγραφή",
  "forecastMaps.mapName": "Όνομα χάρτη",
  "forecastMaps.mapNameRequired": "Εισαγάγετε ένα όνομα",
  "forecastMaps.mapSettings": "Ρυθμίσεις χάρτη",
  "forecastMaps.mapView": "Διαδραστικός χάρτης",
  "forecastMaps.maxLayersReached": "Αυτός ο χάρτης έφτασε το μέγιστο των {max} επιπέδων.",
  "forecastMaps.maxValue": "Μέγιστη τιμή",
  "forecastMaps.memoryBudgetExceeded": "Η ανάλυση υπερβαίνει τον προϋπολογισμό απόδοσης — μειώστε το DPI ή το ύψος",
  "forecastMaps.memoryBudgetUsage": "Προϋπολογισμός απόδοσης: {percent}%",
  "forecastMaps.metaDescription": "Κινούμενοι χάρτες πρόγνωσης από τους υπολογισμούς των μετεωρολογικών μοντέλων.",
  "forecastMaps.metric": "Μέγεθος μέτρησης",
  "forecastMaps.metricRequired": "Επιλέξτε ένα μέγεθος",
  "forecastMaps.metricUnavailable": "Μη διαθέσιμο για αυτό το μοντέλο",
  "forecastMaps.minBelowMax": "Το ελάχιστο πρέπει να είναι μικρότερο από το μέγιστο",
  "forecastMaps.minMaxRequired": "Οι ελάχιστες και μέγιστες τιμές είναι υποχρεωτικές για αυτόν τον τύπο επιπέδου",
  "forecastMaps.minValue": "Ελάχιστη τιμή",
  "forecastMaps.modelNoRun": "Δεν υπάρχει ολοκληρωμένη εκτέλεση ακόμη",
  "forecastMaps.moveLayerDown": "Μετακίνηση κάτω",
  "forecastMaps.moveLayerUp": "Μετακίνηση πάνω",
  "forecastMaps.myMaps": "Οι χάρτες μου",
  "forecastMaps.nanClipToMin": "Περιορισμός στο ελάχιστο",
  "forecastMaps.nanMask": "Μάσκα",
  "forecastMaps.nanPolicy": "Ελλιπή δεδομένα",
  "forecastMaps.nanSkip": "Παράλειψη",
  "forecastMaps.newMap": "Νέος χάρτης",
  "forecastMaps.noCompletedRun": "Αυτός ο χάρτης δεν έχει δημιουργηθεί ακόμη. Ελέγξτε ξανά σύντομα.",
  "forecastMaps.noLayers": "Δεν υπάρχουν επίπεδα ακόμη. Προσθέστε ένα επίπεδο για να ξεκινήσετε.",
  "forecastMaps.noMapsAvailable": "Δεν υπάρχουν ακόμη διαθέσιμοι χάρτες πρόγνωσης.",
  "forecastMaps.north": "Βορράς",
  "forecastMaps.opacity": "Αδιαφάνεια",
  "forecastMaps.overlayLegend": "Υπόμνημα",
  "forecastMaps.pause": "Παύση",
  "forecastMaps.play": "Αναπαραγωγή",
  "forecastMaps.pointValueError": "Δεν ήταν δυνατή η φόρτωση της πρόγνωσης για αυτό το σημείο.",
  "forecastMaps.pointValueLoading": "Φόρτωση πρόγνωσης…",
  "forecastMaps.pointValueUnavailable": "Δεν υπάρχουν δεδομένα για αυτήν την ώρα.",
  "forecastMaps.presets": "Πρότυπα",
  "forecastMaps.preview": "Προεπισκόπηση",
  "forecastMaps.previewEmptyHint": "Ρυθμίστε τουλάχιστον ένα έγκυρο επίπεδο για να αποδοθεί προεπισκόπηση.",
  "forecastMaps.previewFailed": "Η προεπισκόπηση απέτυχε",
  "forecastMaps.previewHour": "Ώρα πρόγνωσης",
  "forecastMaps.previewRendering": "Απόδοση προεπισκόπησης…",
  "forecastMaps.projection": "Προβολή",
  "forecastMaps.projectionLambertConformal": "Σύμμορφη Lambert",
  "forecastMaps.projectionMercator": "Μερκατορική",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Στερεογραφική",
  "forecastMaps.regionEurope": "Ευρώπη",
  "forecastMaps.regionNorthAmerica": "Βόρεια Αμερική",
  "forecastMaps.removeColor": "Αφαίρεση χρώματος",
  "forecastMaps.removeLayer": "Αφαίρεση επιπέδου",
  "forecastMaps.retry": "Δοκιμάστε ξανά",
  "forecastMaps.run": "Εκτέλεση: {run}",
  "forecastMaps.save": "Αποθήκευση",
  "forecastMaps.selectExtentOnMap": "Επιλογή περιοχής στον χάρτη",
  "forecastMaps.south": "Νότος",
  "forecastMaps.title": "Χάρτες πρόγνωσης",
  "forecastMaps.uMetric": "Συνιστώσα U",
  "forecastMaps.unitConversion": "Μετατροπή μονάδων",
  "forecastMaps.unitNone": "Καμία",
  "forecastMaps.unsavedChangesBody": "Έχετε μη αποθηκευμένες αλλαγές. Έξοδος και απόρριψή τους;",
  "forecastMaps.unsavedChangesTitle": "Μη αποθηκευμένες αλλαγές",
  "forecastMaps.useCurrentView": "Χρήση τρέχουσας προβολής",
  "forecastMaps.useModelDomain": "Ανενεργό: χρησιμοποιείται ολόκληρο το πεδίο του μοντέλου",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Τα μεγέθη U και V πρέπει να διαφέρουν",
  "forecastMaps.validTime": "Ισχύει: {time}",
  "forecastMaps.valueBetween": "Πρέπει να είναι μεταξύ {min} και {max}",
  "forecastMaps.variable": "Μεταβλητή",
  "forecastMaps.viewMap": "Προβολή χάρτη",
  "forecastMaps.vMetric": "Συνιστώσα V",
  "forecastMaps.west": "Δύση",
  "forecastMaps.windAnimation": "Κίνηση ανέμου",
  "intro.locationDescription": "Ενεργοποίησε την πρόσβαση τοποθεσίας για ακριβείς προβλέψεις για την περιοχή σου — τέλος στις γενικές προβλέψεις.",
  "intro.locationTitle": "Προβλέψεις για εσένα",
  "intro.notificationDescription": "Ενεργοποίησε τις ειδοποιήσεις για να λαμβάνεις έγκαιρες προειδοποιήσεις για σημαντικές αλλαγές στον καιρό — βροχή, χιόνι ή ακραίες συνθήκες.",
  "intro.notificationsTitle": "Μην χάνεις καμία αλλαγή καιρού",
  "intro.readyDescription": "Απόλαυσε ακριβείς προβλέψεις, ενημερώσεις σε πραγματικό χρόνο και δεδομένα σταθμών από όλο τον κόσμο — όλα σε μία ισχυρή εφαρμογή.",
  "intro.readyTitle": "Είσαι έτοιμος!",
  "intro.welcomeDescription": "Λάβε υπερτοπικές προβλέψεις από κορυφαίες μετεωρολογικές υπηρεσίες και δες πραγματικές καιρικές συνθήκες, παρελθόν και παρόν, από περισσότερους από 40.000 σταθμούς παγκοσμίως.",
  "intro.welcomeTitle": "Ο καιρός σας, ανανεωμένος",
  "landing.alerts": "Ειδοποιήσεις",
  "landing.alertsDescription": "Δημιουργήστε τις δικές σας ειδοποιήσεις και ειδοποιηθείτε αμέσως μόλις ενεργοποιηθούν.",
  "landing.featureAlertsDescription": "Ρυθμίστε προσαρμοσμένες ειδοποιήσεις για συνθήκες που σας ενδιαφέρουν—θερμοκρασία, άνεμος, βροχόπτωση και άλλα.",
  "landing.featureAlertsTitle": "Έξυπνες ειδοποιήσεις",
  "landing.featureAnalyticsDescription": "Εμβαθύνετε στα δεδομένα σας με διαδραστικά γραφήματα, συγκρίσεις δίπλα-δίπλα και ανάλυση τάσεων πέρα από τις βασικές μετρήσεις.",
  "landing.featureAnalyticsTitle": "Ισχυρή αναλυτική",
  "landing.featureExportDescription": "Κατεβάστε τα δεδομένα σας σε μορφή CSV για ανάλυση στο Excel, ενσωμάτωση με άλλα συστήματα ή αντίγραφο ασφαλείας.",
  "landing.featureExportTitle": "Εξαγωγή παντού",
  "landing.featureForecastDescription": "Πρόσβαση σε 10+ επαγγελματικά μοντέλα πρόγνωσης, συμπεριλαμβανομένων ECMWF, GFS και περιφερειακών μοντέλων. Συγκρίνετέ τα δίπλα-δίπλα για τις δικές σας προβλέψεις.",
  "landing.featureForecastTitle": "Σύγκριση μοντέλων πρόγνωσης",
  "landing.featureHistoryDescription": "Πρόσβαση σε ιστορικά δεδομένα με ωριαία, ημερήσια και μηνιαία κλίμακα. Εξαγωγή σε CSV για έρευνα ή προσωπικά αρχεία.",
  "landing.featureHistoryTitle": "Πλούσιο ιστορικό",
  "landing.featureMultiBrandDescription": "Συνδέστε σταθμούς από Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow και άλλα—όλα σε έναν πίνακα ελέγχου.",
  "landing.featureMultiBrandTitle": "Υποστήριξη πολλαπλών μαρκών",
  "landing.featuresSubtitle": "Σχεδιασμένο για λάτρεις του καιρού που απαιτούν περισσότερα από μια βασική εφαρμογή μετεωρολογικού σταθμού.",
  "landing.featuresTitle": "Ό,τι χρειάζεστε για ανάλυση καιρού",
  "landing.finalCtaButton": "Δημιουργία δωρεάν λογαριασμού",
  "landing.finalCtaSubtitle": "Γίνετε μέλη χιλιάδων λάτρεων του καιρού που εμπιστεύονται το SmartMixin για τα μετεωρολογικά τους δεδομένα.",
  "landing.finalCtaTitle": "Έτοιμοι να βελτιώσετε την εμπειρία καιρού σας;",
  "landing.forecastDescription": "Αποκτήστε πρόσβαση σε μερικά από τα καλύτερα μοντέλα πρόγνωσης καιρού και συγκρίνετε τα για να αποκτήσετε τη δική σας ιδέα για το πώς θα είναι ο καιρός",
  "landing.forecasts": "Προγνώσεις",
  "landing.heroCta": "Ξεκινήστε δωρεάν",
  "landing.heroDescription": "Συνδυάστε πολλαπλούς μετεωρολογικούς σταθμούς οποιασδήποτε μάρκας, συγκρίνετε μοντέλα πρόβλεψης και αναλύστε τα δεδομένα σας με λεπτομερή γραφήματα και εξαγωγές.",
  "landing.heroSecondaryCta": "Εξερευνήστε τον χάρτη",
  "landing.heroTagline": "Για λάτρεις του καιρού",
  "landing.heroTitle": "Όλα τα μετεωρολογικά δεδομένα. Μία πλατφόρμα.",
  "landing.pricingFeatureAdvancedMetrics": "Προηγμένες μετρήσεις",
  "landing.pricingFeatureAlerts": "Προσαρμοσμένες ειδοποιήσεις",
  "landing.pricingFeatureExport": "Εξαγωγή δεδομένων (CSV)",
  "landing.pricingFeatureForecastComparison": "Σύγκριση προβλέψεων",
  "landing.pricingFeatureForecasts": "Μοντέλα πρόβλεψης",
  "landing.pricingFeatureForecastsFreeTier": "1 μοντέλο",
  "landing.pricingFeatureForecastsPremiumTier": "Όλα τα μοντέλα (10+)",
  "landing.pricingFeatureReports": "Αναλύσεις & αναφορές",
  "landing.pricingFeatureStationComparison": "Σύγκριση σταθμών",
  "landing.pricingFeatureWidgets": "Widgets αρχικής οθόνης",
  "landing.pricingFeatureYearOverYear": "Ανάλυση έτος με έτος",
  "landing.pricingFree": "Δωρεάν",
  "landing.pricingFreeCta": "Ξεκινήστε",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Πιο δημοφιλές",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Ξεκινήστε",
  "landing.pricingPremiumDescription": "Από 1,99 €/μήνα — εγγραφείτε στο web, App Store ή Google Play",
  "landing.pricingSubtitle": "Ξεκινήστε δωρεάν, αναβαθμιστείτε όταν χρειαστείτε περισσότερα.",
  "landing.pricingTitle": "Απλή, διαφανής τιμολόγηση",
  "landing.smartMixinDescription": "Το SmartMixin είναι μια εφαρμογή που παρέχει πρόσβαση στο μετεωρολογικό σας σταθμό και σε πάνω από 40.000 άλλους σταθμούς παγκοσμίως. Σας βοηθά να βλέπετε και να κατανοείτε τα δεδομένα του καιρού.",
  "landing.statBrands": "Υποστηριζόμενες μάρκες",
  "landing.statForecasts": "Μοντέλα πρόγνωσης",
  "landing.statStations": "Μετεωρολογικοί σταθμοί",
  "landing.supportedDevices": "Υποστηριζόμενες μονάδες",
  "landing.supportedDevicesDescription": "Εκτός από τους σταθμούς του Παγκόσμιου Μετεωρολογικού Οργανισμού, το SmartMixin υποστηρίζει έναν αυξανόμενο αριθμό εμπορικών μαρκών μετεωρολογικών σταθμών",
  "landing.supportedDevicesNote": "Επιπλέον πάνω από 40.000 δημόσιοι σταθμοί του Παγκόσμιου Μετεωρολογικού Οργανισμού",
  "landing.supportedDevicesSubtitle": "Συνδέστε μετεωρολογικούς σταθμούς κορυφαίων μαρκών και δείτε όλα τα δεδομένα σε ένα μέρος.",
  "landing.supportedDevicesTitle": "Λειτουργεί με τους σταθμούς σας",
  "landing.thermostatDescription": "Συνδέστε τον θερμοστάτη Netatmo σας για να συσχετίσετε τα μοτίβα θέρμανσης με τις εξωτερικές συνθήκες.",
  "landing.thermostatManufacturers": "Οι κατασκευαστές θερμοστατών υποστηρίζονται επίσης για τη συσχέτιση της θέρμανσης με τις εξωτερικές συνθήκες.",
  "landing.thermostatTitle": "Ενσωμάτωση έξυπνου σπιτιού",
  "landing.weatherAnalysis": "Ανάλυση καιρού",
  "landing.weatherAnalysisDescription": "Το SmartMixin διαθέτει πολλά δεδομένα απεικόνισης που σας επιτρέπουν να αναλύετε τα δεδομένα καιρού.",
  "landing.weatherAssistant": "Ο βοηθός σας για τον καιρό.",
  "landing.weatherAssistantDescription": "Είτε ενδιαφέρεστε για τις τρέχουσες, ιστορικές ή προγνωστικές καιρικές συνθήκες, το SmartMixin παρέχει πολλές πληροφορίες όποτε τις χρειάζεστε.",
  "landing.weatherForecastModels": "Μοντέλα πρόγνωσης καιρού.",
  "landing.weatherForecastModelsDescription": "Το SmartMixin παρέχει πρόσβαση στα πιο ακριβή μοντέλα πρόγνωσης καιρού. Μπορείτε εύκολα να συγκρίνετε τις προβλέψεις τους και να σχηματίσετε τη δική σας ιδέα.",
  "landing.weatherMap": "Χάρτης καιρού",
  "landing.weatherMapDescription": "Περιηγηθείτε στο χάρτη και δείτε πώς είναι ο καιρός οπουδήποτε στον κόσμο.",
  "network.cancelError": "Το αίτημα έχει ακυρωθεί",
  "network.connectionError": "Ο διακομιστής (Server) δεν είναι διαθέσιμος",
  "network.networkError": "Το δίκτυο δεν είναι διαθέσιμο",
  "network.serverError": "Κάτι πήγε λάθος...",
  "network.timeoutError": "Λήξη χρόνου σύνδεσης",
  "network.unknownError": "Άγνωστο λάθος",
  "providerHints.ambientWeatherApiKey": "Δημιουργείται στις ρυθμίσεις του λογαριασμού σας στο ambientweather.net.",
  "providerHints.davisApiSecret": "Εμφανίζεται μόνο μία φορά κατά τη δημιουργία του κλειδιού V2 API — φυλάξτε το με ασφάλεια.",
  "providerHints.davisV2ApiKey": "Από τη σελίδα κλειδιών V2 API στο weatherlink.com.",
  "providerHints.ecowittApi": "Από τη σελίδα API του λογαριασμού σας Ecowitt.",
  "providerHints.ecowittApp": "Το κλειδί εφαρμογής, επίσης από τον λογαριασμό σας Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Χρησιμοποιήστε email και κωδικό του λογαριασμού σας My AcuRite — όχι τη σύνδεση SmartMixin.",
  "providerHints.myAcuriteEmail": "Το email του λογαριασμού σας My AcuRite — όχι η σύνδεσή σας στο SmartMixin.",
  "providerHints.myAcuritePassword": "Ο κωδικός του λογαριασμού σας My AcuRite.",
  "providerHints.weatherflowToken": "Προσωπικό token από tempestwx.com → ρυθμίσεις → εξουσιοδοτήσεις δεδομένων.",
  "providerHints.wundergroundEditKey": "Χρήση άλλου κλειδιού",
  "providerHints.wundergroundKey": "Μια μακριά συμβολοσειρά από τη σελίδα κλειδιών API του λογαριασμού σας Weather Underground — όχι ο κωδικός σας στο wunderground.com.",
  "providerHints.wundergroundKeyExample": "π.χ. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Το κλειδί API επαληθεύτηκε",
  "providerHints.wundergroundKeyVerifying": "Έλεγχος κλειδιού…",
  "providerHints.wundergroundNoStationsNearby": "Δεν βρέθηκαν σταθμοί κοντά σε αυτή την τοποθεσία. Δοκιμάστε να εισαγάγετε απευθείας ID σταθμού.",
  "providerHints.wundergroundStationId": "Οποιοδήποτε αναγνωριστικό σταθμού Weather Underground — δικός σας ή δημόσιος σταθμός κοντά σας.",
  "providerHints.wundergroundStationIdExample": "π.χ. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Πάρτε το κλειδί API Ambient Weather.",
  "providerIntro.davisStep2": "Πάρτε το κλειδί V2 API και το μυστικό API Davis.",
  "providerIntro.ecowittStep2": "Πάρτε το κλειδί API και το κλειδί εφαρμογής Ecowitt.",
  "providerIntro.getStarted": "Έναρξη",
  "providerIntro.myAcuriteStep2": "Χρησιμοποιήστε email και κωδικό του υπάρχοντος λογαριασμού σας My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Συνδεθείτε στο Netatmo όταν σας ζητηθεί — δεν απαιτείται κλειδί API.",
  "providerIntro.netatmoWeatherStep2": "Συνδεθείτε στο Netatmo όταν σας ζητηθεί — δεν απαιτείται κλειδί API.",
  "providerIntro.signupBanner": "Σχεδόν τελειώσατε — δημιουργήστε τον δωρεάν λογαριασμό σας SmartMixin για να συνδέσετε το {provider}.",
  "providerIntro.step1": "Συνδεθείτε στον λογαριασμό σας SmartMixin (ΟΧΙ στο {provider}).",
  "providerIntro.step3EmailPassword": "Εισαγάγετε τα εδώ.",
  "providerIntro.step3KeyOrToken": "Επικολλήστε εδώ.",
  "providerIntro.step3OAuth": "Εξουσιοδοτήστε το SmartMixin στο αναδυόμενο παράθυρο.",
  "providerIntro.step3Wunderground": "Επικολλήστε το κλειδί API σας και στη συνέχεια επιλέξτε έναν κοντινό σταθμό ή εισαγάγετε οποιοδήποτε ID σταθμού.",
  "providerIntro.title": "Σύνδεση {provider}",
  "providerIntro.weatherflowStep2": "Πάρτε το προσωπικό σας token Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Δεν έχετε σταθμό; Περιηγηθείτε στους δημόσιους",
  "providerIntro.wundergroundFindNearby": "Βρείτε σταθμούς κοντά μου",
  "providerIntro.wundergroundOrEnterId": "Ή εισαγάγετε ID σταθμού",
  "providerIntro.wundergroundStep2": "Πάρτε το κλειδί API Weather Underground. Στη συνέχεια θα μπορείτε να συνδέσετε οποιονδήποτε σταθμό — δικό σας ή δημόσιο.",
  "reports.agroMeteorology": "Αγρομετεωρολογία",
  "reports.analysis": "Ανάλυση",
  "reports.annualCumulativeRainfallComparison": "Σύγκριση συνόλου ετήσιας βροχόπτωσης",
  "reports.annualHeatingDurationComparison": "Σύγκριση ετήσιας διάρκειας θέρμανσης",
  "reports.annualHeatingEfficiency": "Ετήσια απόδοση θέρμανσης",
  "reports.annualIndoorComparison": "Ετήσια σύγκριση εσωτερικού χώρου",
  "reports.annualIndoorReport": "Ετήσια αναφορά εσωτερικού χώρου",
  "reports.annualOutdoorComparison": "Ετήσια σύγκριση εξωτερικού χώρου",
  "reports.annualOutdoorReport": "Ετήσια αναφορά εξωτερικού χώρου",
  "reports.annualReport": "Ετήσια αναφορά",
  "reports.annualSolarReport": "Ετήσια αναφορά ηλιακής ενέργειας",
  "reports.annualWaterBalance": "Ετήσιο ισοζύγιο νερού",
  "reports.annualWaterBalanceCarryOver": "Μεταφορά προηγούμενου έτους",
  "reports.annualWaterBalanceDescription": "Το ισοζύγιο νερού (απλουστευμένη έκδοση, χρησιμοποιούνται μόνο η βροχή και η εξάτμιση του νερού) συμβάλλει στη διαχείριση της προσφοράς νερού.",
  "reports.avgHumidity": "Μέση υγρασία",
  "reports.avgMaxTemperature": "Μέσος όρος T ° max",
  "reports.avgMetric": "Μέσος όρος – {metric}",
  "reports.avgMinTemperature": "Μέσος όρος Τ ° min",
  "reports.avgPressure": "Μέση πίεση",
  "reports.avgTemperature": "Μέση θερμοκρασία",
  "reports.climateNormalPeriodOfRecord": "Περίοδος καταγραφής ({years, plural, one {# έτος} other {# έτη}})",
  "reports.climateNormals": "Κλιματικές κανονικές τιμές",
  "reports.climateNormalStandardLabel": "Τυπική κανονική τιμή ({period})",
  "reports.climateTrendPerDecade": "Τάση θερμοκρασίας: {value} ανά δεκαετία σε διάστημα {years, plural, one {# έτους} other {# ετών}}",
  "reports.coldestMonthRanking": "Ψυχρότερος {month} όλων των εποχών",
  "reports.comfortable": "Άνετη (45% {lessThan} Υγρασία ≤ 60%)",
  "reports.cumulativeRainfall": "Συσσωρευτική βροχόπτωση",
  "reports.cumulativeRainfallDescription": "Παρακολουθήστε τη συνολική βροχόπτωση που συσσωρεύεται στην επιλεγμένη περίοδο.",
  "reports.dailyMaxRainfall": "Μέγιστη ημερήσια βροχόπτωση",
  "reports.dataExport": "Εξαγωγή δεδομένων",
  "reports.dataExportXlsxFormatDescription": "Εξάγετε όλα τα δεδομένα του σταθμού σας σε μορφή Excel (*.xlsx). Μόλις κάνετε κλικ στο κουμπί, θα λάβετε ένα μήνυμα ηλεκτρονικού ταχυδρομείου με τα επεξεργασμένα δεδομένα μετά από λίγα λεπτά",
  "reports.daysWithFrost": "Ημέρες με παγετό",
  "reports.daysWithHeavyRain": "Ημέρες με έντονη βροχή (≥ {threshold})",
  "reports.daysWithoutThaw": "Ημέρες χωρίς απόψυξη",
  "reports.daysWithStrongFrost": "Ημέρες με ισχυρό παγετό",
  "reports.emailSent": "Ένα email έχει σταλεί στο γραμματοκιβώτιο σας",
  "reports.frostDays": "Ημέρες παγετού",
  "reports.grasslandTemperatureSum": "Συνολική θερμοκρασία λιβαδιών (Αγρομετεωρολογία ένδειξη GTS)",
  "reports.grasslandTemperatureSumDescription": "Εάν την άνοιξη το άθροισμα του {threshold} ξεπεραστεί, η βιώσιμη έναρξη της βλάστησης έχει επιτευχθεί (εφαρμόζεται στην Ευρώπη).",
  "reports.growingDegreeDays": "Βαθμοημέρες ανάπτυξης",
  "reports.highPressure": "Αντικυκλώνας (Μέση πίεση ≥ 1013mbar)",
  "reports.iceDays": "Ημέρες συνεχούς παγετού",
  "reports.indoorReport": "Αναφορά εσωτερικών χώρων",
  "reports.keyFacts": "Βασικά γεγονότα",
  "reports.longestDrySpell": "Μεγαλύτερη ξηρή περίοδος",
  "reports.longestRunOfRainyDays": "Η μεγαλύτερη διάρκεια βροχερών ημερών",
  "reports.longestRunWithoutRun": "Το μεγαλύτερο χρονικό διάστημα χωρίς βροχή",
  "reports.longestWetSpell": "Μεγαλύτερη βροχερή περίοδος",
  "reports.lowPressure": "Χαμηλή πίεση (Μέση πίεση {lessThan} 1013mbar)",
  "reports.maxHumidity": "Μέγιστη υγρασία",
  "reports.maxMetric": "Μέγιστο – {metric}",
  "reports.maxPressure": "Μέγιστη πίεση",
  "reports.maxPressureMagnitude24h": "Μέγιστο μέγεθος (/24h)",
  "reports.maxTemperature": "Μέγιστη θερμοκρασία",
  "reports.maxTempGreaterThan": "T ° μέγιστη ≥",
  "reports.maxTempMagnitude24h": "Μέγιστο μέγεθος (/24h)",
  "reports.minHumidity": "Ελάχιστη υγρασία",
  "reports.minMetric": "Ελάχιστο – {metric}",
  "reports.minPressure": "Ελάχιστη πίεση",
  "reports.minPressureMagnitude24h": "Ελάχιστο μέγεθος (/24H)",
  "reports.minTemperature": "Ελάχιστη θερμοκρασία",
  "reports.minTempMagnitude24h": "Ελάχιστο μέγεθος (/24H)",
  "reports.monthlyHeatingEfficiency": "Μηνιαία αποτελεσματικότητα θέρμανσης",
  "reports.monthlyIndoorReport": "Μηνιαία αναφορά εσωτερικού χώρου",
  "reports.monthlyOutdoorReport": "Μηνιαία αναφορά εξωτερικού χώρου",
  "reports.monthlyReport": "Μηνιαία αναφορά",
  "reports.monthlySolarReport": "Μηνιαία αναφορά ηλιακής ενέργειας",
  "reports.monthlyWindReport": "Μηνιαία αναφορά αιολικής ενέργειας",
  "reports.numberOfDays": "Αριθμός ημερών",
  "reports.onThisDayInHistory": "Σαν σήμερα",
  "reports.outdoorReport": "Αναφορά εξωτερικού χώρου",
  "reports.rainfall": "Βροχόπτωση",
  "reports.rainyDays": "Βροχερές μέρες",
  "reports.recordDailyRain": "Πιο βροχερή ημέρα",
  "reports.recordHigh": "Ρεκόρ ζέστης",
  "reports.recordLow": "Ρεκόρ ψύχους",
  "reports.recordsAndClimatology": "Ρεκόρ και κλίμα",
  "reports.recordsSince": "Ρεκόρ από {date}",
  "reports.recordWindGust": "Ισχυρότερη ριπή ανέμου",
  "reports.relativelyWet": "Σχετικά υγρό (60% {lessThan} υγρασία ≤ 80%)",
  "reports.sendEmail": "Αποστολή email",
  "reports.summerDays": "Θερινές ημέρες",
  "reports.tooDry": "Πολύ ξηρό (υγρασία ≤ 45%)",
  "reports.tooWet": "Πολύ υγρό (υγρασία {greaterThan} 80%)",
  "reports.tropicalNights": "Τροπικές νύχτες",
  "reports.warmestMonthRanking": "Θερμότερος {month} όλων των εποχών",
  "reports.waterBalance": "Ισοζύγιο νερού",
  "reports.yearsOfData": "{years, plural, one {# χρόνος} other {# χρόνια}} δεδομένων",
  "reports.yearToDateTemperature": "Θερμοκρασία από το έτος έως σήμερα",
  "reports.yearToDateTemperatureComparison": "Σύγκριση θερμοκρασίας από την αρχή του έτους",
  "sensors.aqiByChannel": "AQI ανά κανάλι",
  "sensors.bgtSensors": "Μαύρη σφαίρα & WBGT",
  "sensors.cameraFeed": "Κάμερα",
  "sensors.compareAqi": "Σύγκριση AQI",
  "sensors.compareHumidity": "Σύγκριση υγρασίας",
  "sensors.compareMoisture": "Σύγκριση εδαφικής υγρασίας",
  "sensors.comparePm25": "Σύγκριση PM2.5",
  "sensors.compareTemperatures": "Σύγκριση θερμοκρασιών",
  "sensors.depthByChannel": "Βάθος ανά κανάλι",
  "sensors.heatStressExtreme": "Ακραία θερμική καταπόνηση",
  "sensors.heatStressModerate": "Μέτρια θερμική καταπόνηση",
  "sensors.heatStressNone": "Χωρίς θερμική καταπόνηση",
  "sensors.heatStressStrong": "Ισχυρή θερμική καταπόνηση",
  "sensors.heatStressVeryStrong": "Πολύ ισχυρή θερμική καταπόνηση",
  "sensors.humidityByChannel": "Υγρασία ανά κανάλι",
  "sensors.indoorAirQuality": "Ποιότητα εσωτερικού αέρα",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Εσωτερικό κλίμα",
  "sensors.indoorCo2Levels": "Επίπεδα CO2",
  "sensors.indoorTemperatureAndHumidity": "Θερμοκρασία & υγρασία",
  "sensors.last24Hours": "24 ώρες",
  "sensors.last30Days": "30 ημέρες",
  "sensors.last7Days": "7 ημέρες",
  "sensors.leafTemperatureByChannel": "Θερμοκρασία φύλλων ανά κανάλι",
  "sensors.leafWetnessByChannel": "Υγρασία φύλλων ανά κανάλι",
  "sensors.lightningSensor": "Κεραυνός",
  "sensors.moistureByChannel": "Εδαφική υγρασία ανά κανάλι",
  "sensors.noDataAvailable": "Δεν υπάρχουν διαθέσιμα δεδομένα",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 ανά κανάλι",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Επιλέξτε κανάλι",
  "sensors.sensorDetailDescription": "Προβολή ιστορικών δεδομένων και τάσεων για τα κανάλια του αισθητήρα.",
  "sensors.sensorHistory": "Ιστορικό αισθητήρα",
  "sensors.soilConductivityByChannel": "Αγωγιμότητα ανά κανάλι",
  "sensors.soilTemperatureByChannel": "Θερμοκρασία εδάφους ανά κανάλι",
  "sensors.strikesToday": "Κεραυνοί σήμερα",
  "sensors.temperatureByChannel": "Θερμοκρασία ανά κανάλι",
  "sensors.viewChart": "Προβολή γραφήματος",
  "settings.about": "Σχετικά",
  "settings.aboutDescription": "Συμφωνία άδειας χρήσης, πολιτική απορρήτου",
  "settings.account": "Λογαριασμός",
  "settings.accountDescription": "Προφίλ, αλλαγή κωδικού πρόσβασης",
  "settings.accountIntro": "Δεδομένα που αφορούν το λογαριασμό σας:",
  "settings.accountSection": "Λογαριασμός",
  "settings.appearance": "Εμφάνιση",
  "settings.appearanceDescription": "Θέμα και επιλογές εμφάνισης",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Αραβικά",
  "settings.availableServices": "Διαθέσιμες",
  "settings.bulgarian": "Βουλγαρικά",
  "settings.cannotDisconnectLastAccount": "Δεν είναι δυνατή η αποσύνδεση της μοναδικής μεθόδου σύνδεσης. Προσθέστε πρώτα μια άλλη μέθοδο σύνδεσης.",
  "settings.catalan": "Καταλανικά",
  "settings.changeEmail": "Αλλαγή email",
  "settings.changePassword": "Αλλαγή κωδικού πρόσβασης",
  "settings.chartGestures": "Κινήσεις σε διαγράμματα",
  "settings.chartGesturesDescription": "Το σύρσιμο στα διαγράμματα αλλάζει τη χρονική περίοδο, το τσίμπημα των διαγραμμάτων αλλάζει τη χρονική κλίμακα",
  "settings.connect": "Σύνδεση",
  "settings.connected": "Συνδεδεμένο",
  "settings.connectedAccounts": "Συνδεδεμένοι λογαριασμοί",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Συνδεδεμένες",
  "settings.connectedSince": "Συνδεδεμένο από {date}",
  "settings.connectionSuccess": "Ο λογαριασμός {provider} συνδέθηκε επιτυχώς",
  "settings.contactUs": "Επικοινωνήστε μαζί μας",
  "settings.contactUsDescription": "Λάβετε βοήθεια ή στείλτε σχόλια",
  "settings.croatian": "Κροατικά",
  "settings.currentPassword": "Τρέχων κωδικός πρόσβασης",
  "settings.czech": "Τσέχικα",
  "settings.danish": "Δανικά",
  "settings.dark": "Σκοτεινή εμφάνιση",
  "settings.dataDisplay": "Εμφάνιση δεδομένων",
  "settings.dateAndTime": "Ημερομηνία και ώρα",
  "settings.disconnect": "Αποσύνδεση",
  "settings.disconnectConfirmation": "Είστε βέβαιοι ότι θέλετε να αποσυνδέσετε τον λογαριασμό {provider};",
  "settings.disconnectionSuccess": "Ο λογαριασμός {provider} αποσυνδέθηκε επιτυχώς",
  "settings.donateButton": "Κάντε μια δωρεά",
  "settings.donateDescription": "Το SmartMixin αναπτύσσεται από μια μικρή ομάδα. Αν σας φαίνεται χρήσιμο, μπορείτε να στηρίξετε την ανάπτυξή του με μια εφάπαξ δωρεά οποιουδήποτε ποσού. Είναι ένα δώρο — δεν αλλάζει το πρόγραμμά σας και δεν ξεκλειδώνει καμία λειτουργία.",
  "settings.donateSuccessBody": "Η δωρεά σας βοηθά το SmartMixin να συνεχίσει να λειτουργεί και να βελτιώνεται. Το εκτιμούμε ειλικρινά.",
  "settings.donateSuccessTitle": "Σας ευχαριστούμε για την υποστήριξη!",
  "settings.donateTitle": "Υποστηρίξτε το SmartMixin",
  "settings.dutch": "Ολλανδικά",
  "settings.emailChange": "Αλλαγή διεύθυνσης email",
  "settings.emailChangeConfirmation": "Επιβεβαίωση αλλαγής email",
  "settings.emailChangeFailure": "Ο σύνδεσμος αλλαγής email δεν είναι έγκυρος ή έχει λήξει.",
  "settings.emailChangeSuccess": "Το email σας άλλαξε επιτυχώς σε {newEmail}.",
  "settings.emailChangeVerificationSent": "Ένα email επιβεβαίωσης στάλθηκε στη νέα σας διεύθυνση email. Ελέγξτε τα εισερχόμενά σας και κάντε κλικ στον σύνδεσμο για να επιβεβαιώσετε την αλλαγή.",
  "settings.english": "Αγγλικά",
  "settings.forecastModelOrderEmpty": "Δεν έχει αποθηκευτεί σειρά — χρησιμοποιούμε το GFS από προεπιλογή.",
  "settings.forecastModelOrderFreeHint": "Τα premium μοντέλα απαιτούν συνδρομή SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Επιλέγουμε το πρώτο μοντέλο της λίστας σας που καλύπτει κάθε σταθμό.",
  "settings.forecastModelOrderReset": "Επαναφορά",
  "settings.forecastModelOrderTitle": "Προεπιλεγμένο μοντέλο πρόβλεψης",
  "settings.forecastModels": "Μοντέλα πρόβλεψης",
  "settings.forecastModelsDescription": "Αναδιάταξη κατά προτίμηση",
  "settings.french": "Γαλλικά",
  "settings.german": "Γερμανικά",
  "settings.gestures": "Κινήσεις",
  "settings.greek": "Ελληνικά",
  "settings.helpCenter": "Κέντρο βοήθειας",
  "settings.helpCenterDescription": "Συχνές ερωτήσεις και οδηγοί",
  "settings.hungarian": "Ουγγρικά",
  "settings.integrationsSection": "Ενσωματώσεις",
  "settings.italian": "Ιταλικά",
  "settings.japanese": "Ιαπωνικά",
  "settings.korean": "Κορεάτικα",
  "settings.language": "Γλώσσα",
  "settings.languageDescription": "Προτιμώμενη γλώσσα",
  "settings.light": "Φωτεινή εμφάνιση",
  "settings.newEmailAddress": "Νέα διεύθυνση email",
  "settings.newPassword": "Νέος κωδικός πρόσβασης",
  "settings.newPasswordAgain": "Νέος κωδικός πρόσβασης, επιβεβαίωση",
  "settings.norwegian": "Νορβηγικά",
  "settings.notConnected": "Δεν είναι συνδεδεμένο",
  "settings.notificationsSection": "Ειδοποιήσεις",
  "settings.oldPassword": "Παλιός κωδικός πρόσβασης",
  "settings.ongoingNotificationEnabled": "Ενεργοποίηση μόνιμης ειδοποίησης",
  "settings.ongoingNotificationMetrics": "Εμφανιζόμενες μετρήσεις",
  "settings.ongoingNotificationMetricsHint": "Σύρετε για αναδιάταξη των επιλεγμένων μετρήσεων",
  "settings.ongoingNotificationPermissionRequired": "Απαιτείται άδεια ειδοποιήσεων",
  "settings.ongoingNotificationStation": "Μετεωρολογικός σταθμός",
  "settings.passwordChange": "Αλλαγή κωδικού πρόσβασης",
  "settings.polish": "Πολωνικά",
  "settings.portuguese": "Πορτογαλικά",
  "settings.preferencesSection": "Προτιμήσεις",
  "settings.premium": "Premium",
  "settings.premiumActive": "Ενεργό",
  "settings.premiumAnnualThenPrice": "Στη συνέχεια 9,99 €/έτος",
  "settings.premiumAnnualTrialInfo": "Ξεκινήστε με μια δωρεάν δοκιμαστική περίοδο {days} ημερών",
  "settings.premiumCurrentPlan": "Τρέχον πρόγραμμα",
  "settings.premiumDescription": "Ξεκλειδώστε premium λειτουργίες",
  "settings.premiumDownloadApp": "Κατεβάστε την εφαρμογή για να εγγραφείτε:",
  "settings.premiumExpiresOn": "Ανανεώνεται στις {date}",
  "settings.premiumFreePlan": "Δωρεάν",
  "settings.premiumInactive": "Χωρίς συνδρομή",
  "settings.premiumManageWebSubscription": "Διαχειριστείτε τη συνδρομή σας, ενημερώστε τον τρόπο πληρωμής ή ακυρώστε.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Ετήσια — 9,99 €/έτος",
  "settings.premiumSubscribedOn": "Εγγραφή μέσω {platform}",
  "settings.premiumSubscribeMonthly": "Μηνιαία — 1,99 €/μήνα",
  "settings.premiumSubscribeOnWeb": "Εγγραφείτε τώρα για να ξεκλειδώσετε όλες τις premium λειτουργίες.",
  "settings.premiumSubscriptionSuccess": "Η συνδρομή σας ενεργοποιήθηκε! Απολαύστε όλες τις premium λειτουργίες.",
  "settings.premiumSubscriptionSuccessTitle": "Καλώς ήρθατε στο Premium!",
  "settings.premiumWebappNotice": "Οι συνδρομές μπορούν να αγοραστούν μόνο μέσω της εφαρμογής SmartMixin για κινητά σε iOS ή Android.",
  "settings.privacyPolicy": "Πολιτική απορρήτου",
  "settings.profile": "Προφίλ",
  "settings.russian": "Ρωσικά",
  "settings.serbian": "Σέρβικα",
  "settings.settings": "Ρυθμίσεις",
  "settings.slovak": "Σλοβάκικα",
  "settings.smallDecimals": "Μικρά δεκαδικά",
  "settings.smallDecimalsDescription": "Εμφάνιση δεκαδικών ψηφίων σε μικρότερο μέγεθος",
  "settings.socialConnectionsIntro": "Συνδέστε τους κοινωνικούς σας λογαριασμούς για γρήγορη σύνδεση. Μπορείτε να συνδέσετε ή να αποσυνδέσετε λογαριασμούς ανά πάσα στιγμή.",
  "settings.spanish": "Ισπανικά",
  "settings.statusBarWidget": "Widget γραμμής κατάστασης",
  "settings.statusBarWidgetDescription": "Πάντα ορατά δεδομένα καιρού",
  "settings.subscriptionSection": "Συνδρομή",
  "settings.supportSection": "Υποστήριξη",
  "settings.swedish": "Σουηδικά",
  "settings.systemTheme": "Εμφάνιση συστήματος",
  "settings.termsOfService": "Όροι παροχής υπηρεσιών",
  "settings.turkish": "Τουρκικά",
  "settings.ukrainian": "Ουκρανικά",
  "settings.units": "Μονάδες",
  "settings.unitsDescription": "Μονάδες μέτρησης που εμφανίζονται στην εφαρμογή",
  "settings.update": "Ενημέρωση",
  "settings.updateYourProfile": "Ενημερώστε το προφίλ σας",
  "settings.weatherServices": "Μετεωρολογικές υπηρεσίες",
  "settings.weatherServicesConnected": "{count, plural, =0 {Καμία υπηρεσία συνδεδεμένη} one {# υπηρεσία συνδεδεμένη} other {# υπηρεσίες συνδεδεμένες}}",
  "settings.weatherServicesDescription": "Συνδέστε Netatmo, Davis, Weatherflow και άλλα",
  "settings.windDirectionConvention": "Βέλος κατεύθυνσης ανέμου",
  "settings.windDirectionConventionDescription": "Επιλέξτε πώς εμφανίζονται τα βέλη κατεύθυνσης ανέμου",
  "settings.windDirectionMeteorological": "Κατεύθυνση προέλευσης",
  "settings.windDirectionMeteorologicalDescription": "Το βέλος δείχνει από πού έρχεται ο άνεμος (μετεωρολογική σύμβαση)",
  "settings.windDirectionOceanographic": "Κατεύθυνση ροής",
  "settings.windDirectionOceanographicDescription": "Το βέλος δείχνει προς τα πού φυσά ο άνεμος (ωκεανογραφική σύμβαση)",
  "units.absolutePressure": "Απόλυτη πίεση",
  "units.airDensity": "Πυκνότητα αέρα",
  "units.airGap": "Διάκενο αέρα",
  "units.apparentTemperature": "Φαινόμενη θερμοκρασία",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Μέσος όρος",
  "units.beaufort": "Μποφόρ",
  "units.blackGlobeTemperature": "Θερμ. μαύρης σφαίρας",
  "units.boilerOn": "Λέβητας σε λειτουργία",
  "units.co2": "CO2",
  "units.conductivity": "Αγωγιμότητα",
  "units.coolingDegreeDays": "Βαθμοημέρες ψύξης",
  "units.dailyHeatingDuration": "Καθημερινή διάρκεια θέρμανσης",
  "units.dailyPrecipitation": "Ημερήσιος υετός",
  "units.dailyRain": "Ημερήσια βροχή",
  "units.degreeDay": "Βαθμοί ημέρας",
  "units.degreeDayShort": "Βαθμός ημέρας",
  "units.depth": "Βάθος",
  "units.depthSensors": "Αισθητήρες βάθους",
  "units.dewPoint": "Σημείο δρόσου",
  "units.distance": "Απόσταση",
  "units.downTrend": "κάτω",
  "units.E": "Α",
  "units.E_long": "Ανατολή",
  "units.ENE": "ΑΒΑ",
  "units.ENE_long": "Ανατολικά-Βορειοανατολικά",
  "units.ESE": "ΑΝΑ",
  "units.ESE_long": "Ανατολικά-Νοτιοανατολικά",
  "units.ET": "Συνολική εξάτμιση",
  "units.ETshort": "ET",
  "units.feelLike": "Αίσθηση Όπως",
  "units.feelsLike": "Αίσθηση Όπως",
  "units.footMile": "Πόδια, μίλια",
  "units.frostPoint": "Σημείο παγετού",
  "units.gust": "Ριπές",
  "units.heatIndex": "Δείκτης θερμοκρασίας",
  "units.heatingDegreeDays": "Βαθμοημέρες θέρμανσης",
  "units.heatingPower": "Ισχύς θέρμανσης",
  "units.humidex": "Δείκτης δυσφορίας Humidex",
  "units.humidity": "Υγρασία",
  "units.inch": "Ίντσα",
  "units.inchOfMercury": "Ίντσα υδραργύρου",
  "units.kilometerPerHour": "Χιλιόμετρα την ώρα",
  "units.knot": "Κόμβος",
  "units.last12Hours": "Τελευταίες 12 ώρες",
  "units.last24Hours": "Τελευταίες 24 ώρες",
  "units.last3Hours": "Τελευταίες 3 ώρες",
  "units.last6Hours": "Τελευταίες 6 ώρες",
  "units.lastHour": "Τελευταία ώρα",
  "units.lastLightningImpact": "Τελευταία επίδραση",
  "units.lastMeasure": "Τελευταία μέτρηση",
  "units.leafSensors": "Αισθητήρες φύλλων",
  "units.leafWetness": "Υγρασία φύλλων",
  "units.lightningDistance": "Απόσταση",
  "units.lightningStrikeCount": "Μετρητής κεραυνών",
  "units.lightningStrikeDistance": "Απόσταση κεραυνού",
  "units.max": "Μέγιστη",
  "units.max_gust": "Μέγιστη ριπή",
  "units.max_wind": "Μέγιστο ανέμου",
  "units.meterKilometer": "Μέτρα, χιλιόμετρα",
  "units.meterPerSecond": "Μέτρα το δευτερόλεπτο",
  "units.milePerHour": "Μίλια την ώρα",
  "units.millibar": "Μιλλιμπάρ",
  "units.millimeter": "Χιλιοστά",
  "units.millimeterOfMercury": "Χιλιοστό υδραργύρου",
  "units.min": "Ελάχιστη",
  "units.N": "Β",
  "units.N_long": "Βόρεια",
  "units.NE": "ΒΑ",
  "units.NE_long": "Βορειοανατολικά",
  "units.NNE": "ΒΒΑ",
  "units.NNE_long": "Βόρεια-Βορειοανατολικά",
  "units.NNW": "ΒΒΔ",
  "units.NNW_long": "Βόρεια-Βορειοδυτικά",
  "units.noise": "Θόρυβος",
  "units.normalizedHeatingCoefficient": "Προσαρμοσμένος συντελεστής θέρμανσης",
  "units.NW": "ΒΔ",
  "units.NW_long": "Βορειοδυτικά",
  "units.O3": "O3",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2,5",
  "units.precipitation": "Βροχόπτωση",
  "units.pressure": "Πίεση",
  "units.rain": "Βροχή",
  "units.rainRate": "Ένταση βροχής",
  "units.referenceTemperature": "Θερμοκρασία αναφοράς",
  "units.relativePressure": "Σχετική πίεση",
  "units.S": "Ν",
  "units.S_long": "Νότια",
  "units.SE": "ΝΑ",
  "units.SE_long": "Νοτιοανατολικά",
  "units.setPoint": "Σημείο ρύθμισης",
  "units.snow": "Χιόνι",
  "units.snowfall": "Χιονόπτωση",
  "units.soilMoisture": "Υγρασία",
  "units.soilSensors": "Αισθητήρες εδάφους",
  "units.solarEnergy": "Ηλιακή ενέργεια",
  "units.solarRadiation": "Ηλιακή ακτινοβολία",
  "units.speed": "Ταχύτητα",
  "units.SSE": "ΝΝΑ",
  "units.SSE_long": "Νότια-Νοτιοανατολικά",
  "units.SSW": "ΝΝΔ",
  "units.SSW_long": "Νότια-Νοτιοδυτικά",
  "units.stableTrend": "σταθερό",
  "units.sum": "Άθροισμα",
  "units.SW": "ΝΔ",
  "units.SW_long": "Νοτιοδυτικά",
  "units.temperature": "Θερμοκρασία",
  "units.temperatureAndHumiditySensors": "Αισθητήρες θερμοκρασίας και υγρασίας αέρος",
  "units.temperatureSensors": "Αισθητήρες θερμοκρασίας και υγρασίας αέρος",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Σήμερα",
  "units.upTrend": "Αυξητική τάση",
  "units.uv": "UV",
  "units.visibility": "Ορατότητα",
  "units.W": "Δ",
  "units.W_long": "Δύση",
  "units.wetBulbGlobeTemperature": "Θερμ. υγρού βολβού",
  "units.wetBulbTemperature": "Χαμηλότερη θερμοκρασία ψύξης μέσω εξάτμισης (Wet bulb temp.)",
  "units.wind": "Άνεμος",
  "units.windChill": "Ψυχρότητα ανέμου",
  "units.windDirection": "Κατεύθυνση ανέμου",
  "units.windRun": "Διαδρομή ανέμου",
  "units.windRunDescription": "Η διαδρομή του ανέμου είναι η συνολική απόσταση που διανύει ο άνεμος κατά τη διάρκεια μιας χρονικής περιόδου.",
  "units.WNW": "ΔΒΔ",
  "units.WNW_long": "Δυτικά-Βορειοδυτικά",
  "units.WSW": "ΔΝΔ",
  "units.WSW_long": "Δυτικά-Νοτιοδυτικά"
}
